import React from 'react';
import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import '@resourcehub/resourcehub-components/src/components/FreeTrial/freeTrialErrors';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var actionTypes$2 = {
  EMAIL_COLLECTION_RESPONSE: "EMAIL_COLLECTION_RESPONSE",
  EMAIL_COLLECTION_STATUS: "EMAIL_COLLECTION_STATUS",
  EMAIL_COLLECTION_SUBMISSION: "EMAIL_COLLECTION_SUBMISSION"
};

var submissionStatus$2 = {
  open: "open",
  sent: "sent",
  received: "received",
  error: "error",
  success: "success",
  complete: "complete"
};
var storeRoot$6 = "emailCollection";

var emailCollectionConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  submissionStatus: submissionStatus$2,
  storeRoot: storeRoot$6
});

var initialFormData$3 = {
  submission: {
    emailAddress: ""
  },
  response: null,
  status: submissionStatus$2.open,
  errors: null
};

var emailCollectionFormReducers$1 = function emailCollectionFormReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFormData$3;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes$2.EMAIL_COLLECTION_SUBMISSION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        submission: action.payload
      });

    case actionTypes$2.EMAIL_COLLECTION_RESPONSE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        response: action.payload
      });

    case actionTypes$2.EMAIL_COLLECTION_STATUS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.payload
      });

    default:
      return state;
  }
};

var LEAD_GENERATION_CLEAR = "LEAD_GENERATION_CLEAR";
var LEAD_GENERATION_RESPONSE = "LEAD_GENERATION_RESPONSE";
var LEAD_GENERATION_STATUS = "LEAD_GENERATION_STATUS";
var LEAD_GENERATION_SUBMISSION = "LEAD_GENERATION_SUBMISSION";
var LEAD_GENERATION_SET_APPOINTMENT = "LEAD_GENERATION_SET_APPOINTMENT";
var LEAD_GENERATION_SET_SCHEDULE = "LEAD_GENERATION_SET_SCHEDULE";
var LEAD_GENERATION_SET_COMPLETION_REDIRECT = "LEAD_GENERATION_SET_COMPLETION_REDIRECT";

var initialState$1 = {
  submission: null,
  response: null,
  status: submissionStatus$2.open,
  errors: null,
  schedule_appointment: false,
  appointment: null,
  completion_redirect: null
};
var leadGenerationReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LEAD_GENERATION_SUBMISSION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        submission: action.payload
      });

    case LEAD_GENERATION_RESPONSE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        response: action.payload
      });

    case LEAD_GENERATION_SET_COMPLETION_REDIRECT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        completion_redirect: action.payload
      });

    case LEAD_GENERATION_SET_SCHEDULE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        schedule_appointment: action.payload
      });

    case LEAD_GENERATION_SET_APPOINTMENT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        appointment: action.payload
      });

    case LEAD_GENERATION_STATUS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.payload
      });

    case LEAD_GENERATION_CLEAR:
      return initialState$1;

    default:
      return state;
  }
});

var storeRoot$5 = "leadGeneration";
var submissionStatus$1 = {
  open: "open",
  sent: "sent",
  received: "received",
  error: "error",
  success: "success",
  complete: "complete"
}; // Deprecate Below When Direct Eloqua Communication is no longer needed

var formConditions = {
  ".com": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "US Business Resources Pricing Form",
        CampaignID: "7010W000002b4xX",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "US Business Webpage Pricing Form",
        CampaignID: "7010W0000023pND",
        subSector1: ""
      },
      consulting: {
        CampaignID: "7010W0000027qbj",
        importSourceMostRecent1: "US CORP Consulting Pricing Form",
        subSector1: "Professional Services",
        omniformname: "corporate"
      },
      manufacturing: {
        CampaignID: "7010W0000027qbe",
        importSourceMostRecent1: "US CORP Manufacturing Pricing Form",
        subSector1: "Manufacturing",
        omniformname: "corporate"
      },
      foodservice: {
        CampaignID: "7010W0000027qbZ",
        importSourceMostRecent1: "US CORP Foodservice Pricing Form",
        subSector1: "Food and Beverage",
        omniformname: "corporate"
      },
      hospitality: {
        CampaignID: "7010W0000027qbU",
        importSourceMostRecent1: "US CORP Hospitality Pricing Form",
        subSector1: "Hospitality",
        omniformname: "corporate"
      },
      construction: {
        CampaignID: "7010W0000027qbK",
        importSourceMostRecent1: "US CORP Construction Pricing Form",
        subSector1: "Construction",
        omniformname: "corporate"
      },
      healthcare: {
        CampaignID: "7010W0000027qbF",
        importSourceMostRecent1: "US CORP Healthcare Pricing Form",
        subSector1: "Healthcare",
        omniformname: "corporate"
      },
      retail: {
        CampaignID: "7010W0000027qbP",
        importSourceMostRecent1: "US CORP Retail Pricing Form",
        subSector1: "Retail",
        omniformname: "corporate"
      },
      government: {
        CampaignID: "7010W000002OLajQAG",
        importSourceMostRecent1: "US CORP Government Pricing Form",
        subSector1: "Government",
        omniformname: "corporate"
      }
    },
    k12: {
      resources: {
        omniformname: "k12",
        importSourceMostRecent1: "US K12 Resources Pricing Form",
        CampaignID: "7010W000002b4xS",
        subSector1: ""
      },
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "US K12 Webpage Pricing Form",
        CampaignID: "7010W0000023pNIQAY",
        subSector1: ""
      },
      solutions: {
        omniformname: "k12",
        CampaignID: "7010W0000023pNIQAY",
        importSourceMostRecent1: "US K12 Solutions Pricing Form",
        subSector1: ""
      }
    },
    pubsec: {
      webpage: {
        omniformname: "pubsec",
        importSourceMostRecent1: "US Public Sector Webpage Pricing Form",
        CampaignID: "7010W000001v8Q9",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "US Higher Education Webpage Pricing Form",
        CampaignID: "7010W000001v8Q4",
        subSector1: ""
      }
    }
  },
  ".co.uk": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "UK Business Resources Pricing Form",
        CampaignID: "7010W0000023r4p",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "UK Business Webpage Pricing Form",
        CampaignID: "7010W0000023pNN",
        subSector1: ""
      },
      consulting: {
        CampaignID: "7010W0000027xcH",
        importSourceMostRecent1: "UK Consulting Pricing Form",
        subSector1: "Professional Services",
        omniformname: "corporate"
      },
      financial: {
        CampaignID: "7010W0000027xcM",
        importSourceMostRecent1: "UK Financial Services Pricing Form",
        subSector1: "Financial Services",
        omniformname: "corporate"
      },
      logistics: {
        CampaignID: "7010W0000027xcC",
        importSourceMostRecent1: "UK Logistics Pricing Form",
        subSector1: "Transport & Logistics",
        omniformname: "corporate"
      },
      manufacturing: {
        CampaignID: "7010W0000027xc7",
        importSourceMostRecent1: "UK Manufacturing Pricing Form",
        subSector1: "Manufacturing",
        omniformname: "corporate"
      },
      pharmaceutical: {
        CampaignID: "7010W0000027xbx",
        importSourceMostRecent1: "UK Pharmaceutical Pricing Form",
        subSector1: "Pharmaceutical",
        omniformname: "corporate"
      },
      retail: {
        CampaignID: "7010W0000027xc2",
        importSourceMostRecent1: "UK Retail Pricing Form",
        subSector1: "Retail",
        omniformname: "corporate"
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "UK K12 Webpage Pricing Form",
        CampaignID: "7010W0000023pNS",
        subSector1: ""
      }
    }
  },
  ".de": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "DE Business Resources Pricing Form",
        CampaignID: "7010W0000023r4u",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "DE Business Webpage Pricing Form",
        CampaignID: "7010W0000023pNc",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "DE EDU Webpage Pricing Form",
        CampaignID: "7010W0000023pNX",
        subSector1: ""
      }
    }
  },
  ".espanol": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "LatAm Business Resources Pricing Form",
        CampaignID: "7010W000001zGtE",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "LatAm Business Webpage Pricing Form",
        CampaignID: "7010W0000023rkq",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "LatAm K12 Webpage Pricing Form",
        CampaignID: "7010W0000023rkv",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "LatAm HED Webpage Pricing Form",
        CampaignID: "7010W000002bHuz",
        subSector1: ""
      }
    }
  },
  ".es": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "ES Business Resources Pricing Form",
        CampaignID: "7010W000001zGtO",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "ES Business Webpage Pricing Form",
        CampaignID: "7010W0000023sL5",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "ES EDU Webpage Pricing Form",
        CampaignID: "7010W0000023sL0",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "ES HED Webpage Pricing Form",
        CampaignID: "7010W000002bHv9",
        subSector1: ""
      }
    }
  },
  ".fr": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "FR Business Resources Pricing Form",
        CampaignID: "7010W000001zGtT",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "FR Business Webpage Pricing Form",
        CampaignID: "7010W0000023sKq",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "FR EDU Webpage Pricing Form",
        CampaignID: "7010W0000023sKv",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "FR HED Webpage Pricing Form",
        CampaignID: "7010W000002bHvE",
        subSector1: ""
      }
    }
  },
  ".br": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "BR Business Resources Pricing Form",
        CampaignID: "7010W000001zGtJ",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "BR Business Webpage Pricing Form",
        CampaignID: "7010W0000023sKl",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "BR EDU Webpage Pricing Form",
        CampaignID: "7010W0000023sKg",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "BR HED Webpage Pricing Form",
        CampaignID: "7010W000002bHv4",
        subSector1: ""
      }
    }
  },
  ".it": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "IT Business Resources Pricing Form",
        CampaignID: "7010W000001zGtd",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "IT Business Webpage Pricing Form",
        CampaignID: "7010W000001zG3w",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "IT EDU Webpage Pricing Form",
        CampaignID: "7010W000001zG41",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "IT HED Webpage Pricing Form",
        CampaignID: "7010W000001zG4B",
        subSector1: ""
      }
    }
  },
  ".cn": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "CN Business Resources Pricing Form",
        CampaignID: "7010W000001v54I",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "CN Business Webpage Pricing Form",
        CampaignID: "7010W000001v543",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "CN EDU Webpage Pricing Form",
        CampaignID: "7010W000001v53j",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "CN HED Webpage Pricing Form",
        CampaignID: "7010W000001v548",
        subSector1: ""
      }
    }
  }
};

var leadGenerationConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeRoot: storeRoot$5,
  submissionStatus: submissionStatus$1,
  formConditions: formConditions
});

var PA_CONFIG = "PA_CONFIG"; // API calls

var PA_VERIFY_ID = "PA_VERIFY_ID";
var PA_CHECK = "PA_CHECK";
var PA_CLAIM = "PA_CLAIM";
var PA_IS_SUBMITTING = "PA_IS_SUBMITTING";
var PA_ID = "PA_ID";
var PA_ID_PART_1 = "PA_ID_PART_1";
var PA_ID_PART_2 = "PA_ID_PART_2";
var PA_ID_PART_3 = "PA_ID_PART_3";
var PA_ID_ERROR = "PA_ID_ERROR";
var PA_CLEAR_ID_ERROR = "PA_CLEAR_ID_ERROR";
var PA_EMAIL_ADDRESS = "PA_EMAIL_ADDRESS";
var PA_EMAIL_ADDRESS_ERROR = "PA_EMAIL_ADDRESS_ERROR";
var PA_CLEAR_EMAIL_ADDRESS_ERROR = "PA_CLEAR_EMAIL_ADDRESS_ERROR";
var PA_TERMS_ACCEPTED = "PA_TERMS_ACCEPTED";
var PA_TERMS_ACCEPTED_ERROR = "PA_TERMS_ACCEPTED_ERROR";
var PA_CLEAR_TERMS_ACCEPTED_ERROR = "PA_CLEAR_TERMS_ACCEPTED_ERROR";
var PA_API_ERROR = "PA_API_ERROR";
var PA_CLEAR_ERRORS = "PA_CLEAR_ERRORS";
var PA_VENDOR = "PA_VENDOR";
var PA_PRODUCT_TYPE = "PA_PRODUCT_TYPE";
var PA_FIRST_NAME = "PA_FIRST_NAME";
var PA_LAST_NAME = "PA_LAST_NAME";
var PA_CONSUMABLES = "PA_CONSUMABLES";
var PA_CONSUMABLES_TYPE = "PA_CONSUMABLES_TYPE";
var PA_ORG_ID = "PA_ORG_ID";
var PA_SERIAL_NUMBER = "PA_SERIAL_NUMBER";
var PA_DURATION = "PA_DURATION";
var PA_CAT_CODE = "PA_CAT_CODE";
var PA_LANG_LIST = "PA_LANG_LIST";
var PA_EXISTING_USER = "PA_EXISTING_USER";
var PA_EXISTING_USER_BOOLEAN = "PA_EXISTING_USER_BOOLEAN"; // ********* PAGE TWO

var PA_SUPPORT_LANGUAGE = "PA_SUPPORT_LANGUAGE";
var PA_REDIRECT_URL = "PA_REDIRECT_URL";
var PA_CHECK_SELECTED_LEARNING_LANGUAGE = "PA_CHECK_SELECTED_LEARNING_LANGUAGE";
var PA_INITIALIZE_PAGE_2 = "PA_INITIALIZE_PAGE_2";
var PA_LICENSES = "PA_LICENSES";
var PA_FIRST_NAME_ERROR = "PA_FIRST_NAME_ERROR";
var PA_LAST_NAME_ERROR = "PA_LAST_NAME_ERROR";
var PA_PASSWORD = "PA_PASSWORD";
var PA_PASSWORD_ERROR = "PA_PASSWORD_ERROR";
var PA_CONFIRM_PASSWORD = "PA_CONFIRM_PASSWORD";
var PA_CONFIRM_PASSWORD_ERROR = "PA_CONFIRM_PASSWORD_ERROR";
var PA_CURRENCY = "PA_CURRENCY";
var PA_CURRENCY_ERROR = "PA_CURRENCY_ERROR";
var PA_LEARNING_LANGUAGE_CODE = "PA_LEARNING_LANGUAGE_CODE";
var PA_LEARNING_LANGUAGE_ERROR = "PA_LEARNING_LANGUAGE_ERROR";
var PA_PAGE_ERROR = "PA_PAGE_ERROR";
var PA_SHOW_PASSWORD = "PA_SHOW_PASSWORD";
var PA_CLEAR_FIRST_NAME_ERROR = "PA_CLEAR_FIRST_NAME_ERROR";
var PA_CLEAR_LAST_NAME_ERROR = "PA_CLEAR_LAST_NAME_ERROR";
var PA_CLEAR_PASSWORD_ERROR = "PA_CLEAR_PASSWORD_ERROR";
var PA_CLEAR_CONFIRM_PASSWORD_ERROR = "PA_CLEAR_CONFIRM_PASSWORD_ERROR";
var PA_CLEAR_CURRENCY_ERROR = "PA_CLEAR_CURRENCY_ERROR";
var PA_CLEAR_LEARNING_LANGUAGE_ERROR = "PA_CLEAR_LEARNING_LANGUAGE_ERROR";
var PA_LEARNING_LANGUAGE_STATE = "PA_LEARNING_LANGUAGE_STATE";
var PA_PRODUCT_NAME = "PA_PRODUCT_NAME";

function ensureString(v) {
  return v ? v : "";
}
function convertToBoolean(s) {
  if (typeof s === "boolean") {
    return s;
  } else if (typeof s === "string") {
    return s.trim().toLowerCase() === "true";
  }

  return false; // i guess we should raise
}
function withTier(path) {
  var stage = "";

  if (window.location.href.search(/(\.stg\.)|(localhost)|(127\.0\.0\.1)|(qa[0-9]+\.)/i) > -1) {
    stage = ".stg";
  }

  return "https://iis-gateway".concat(stage, ".rosettastone.com/") + path;
}

var storeRoot$4 = "productActivation";
var currencyMap = {
  usd: {
    orgId: "83",
    currency: "USD"
  },
  yen: {
    orgId: "224",
    currency: "JPY"
  },
  won: {
    orgId: "2885",
    currency: "KRW"
  },
  gbp: {
    orgId: "204",
    currency: "GBP"
  },
  euro: {
    orgId: "3285",
    currency: "EUR"
  }
};
var translations = {
  "en-US": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "Start learning right now.",
      reqError: "There was an issue processing your request. Please call: 1-800-ROSETTA FREE for support.",
      claimProdTypeErr: 'This activation code is for a CD-ROM or Download product. To activate your product, please follow the <a href="//support.rosettastone.com/en/language-learning/articles/Activating-Rosetta-Stone-Version-4-TOTALe/">instructions here.</a>',
      formDesc: 'Please enter your Activation Code. Find it <a href="#" id="form-help-link">here</a>.',
      claimEmptyErr: "Please enter your Activation Code.",
      claimInvalidActivationCodeErr: "Invalid Activation Code.",
      claimAlreadyActivatedErr: 'Your claim code has already been activated. <a href="//support.rosettastone.com/en/language-learning/articles/How-do-I-enter-my-Claim-Code" target="_blank">Need Help?</a>',
      claim500Err: 'Something went wrong. Please contact the <a href="//support.rosettastone.com/" target="_blank">Product Support</a> team.',
      email: "E-mail address (this will be your username)",
      emailErr: "Please enter a valid e-mail address",
      terms: 'By checking here, you agree to our <a href="/termsonline">Terms of Use</a> and <a href="/privacy">Privacy Policy.</a>',
      termsErr: "You must accept the terms of service",
      startActivationButton: "START ACTIVATION",
      help: {
        h1: "Where can I find my Activation Code?",
        boxedProducts: "Boxed Products",
        boxedProductsText: "You can find your activation code on the card or booklet that's included with your box.",
        gift: "Gift Card",
        giftText: "You can find your activation code on the back of your card.",
        email: "E-mail Confirmation",
        emailText: "You can find your activation code in your order confirmation email.",
        conditions: "Activation codes are a string of alpha-numeric characters."
      }
    },
    pg2: {
      firstName: "First name",
      firstNameErr: "Please enter your first name",
      lastName: "Last name",
      lastNameErr: "Please enter your last name",
      password: "Create Password",
      passwordErr: "Please enter password",
      confirm: "Confirm Password",
      confirmErr: "Please enter confirm password",
      matchErr: "Passwords do not match",
      show: "Show password",
      currencyLabel: "For future transactions",
      currency: "Select Currency",
      currencyErr: "Please select a currency",
      supportLabel: "Just in case you need our help",
      support: "Support Language",
      supportErr: "Please select a support language",
      learningLabel: "What would you like to learn?",
      learning: "Select learning language",
      learningErr: "Please select a language to learn",
      singleLearning: "You will be learning:",
      button: "Finish Activation",
      processing: "Processing ...",
      amz: "A user with this email address already has access to LANGUAGE_NAME through Amazon Subscriptions. You can manage your Amazon subscription <a href='AMAZON_LINK'>here.</a> Please enter an alternative email address, or select another language you would like to learn.",
      apple: "A user with this email address already has access to LANGUAGE_NAME through the Apple App Store. Please enter an alternative email address, or select another language you would like to learn.",
      google: "A user with this email address already has access to LANGUAGE_NAME through the Google Play store. Please enter an alternative email address, or select another language you would like to learn.",
      mo: "You currently already have access to Learn Languages with Rosetta Stone through your Rosetta Stone Online Subscription. Please enter alternative email address or select another language the you would like to learn.",
      hs: "A user with this email address has access to another Rosetta Stone subscription. Please enter an alternative email address to activate and access your Homeschool product.",
      tsub: "This email address has been used previously to activate and access the Homeschool product. Please enter an alternative email address to continue.",
      supportLanguages: ["English", "Portuguese", "French", "Italian", "Japanese", "Spanish", "German", "Korean"],
      currencies: ["USD ($)", "Yen (¥)", "Won (₩)", "GBP (£)", "Euro (€)"],
      learningLanguages: [{
        code: "all",
        text: "Rosetta Stone Unlimited Languages"
      }, {
        code: "ame",
        text: "English (American)"
      }, {
        code: "ara",
        text: "Arabic"
      }, {
        code: "chi",
        text: "Chinese (Mandarin)"
      }, {
        code: "dar",
        text: "Dari"
      }, {
        code: "deu",
        text: "German"
      }, {
        code: "ebr",
        text: "English (British)"
      }, {
        code: "ecs",
        text: "Spanish"
      }, {
        code: "eng",
        text: "English (American)"
      }, {
        code: "esc",
        text: "Spanish (Spain)"
      }, {
        code: "esp",
        text: "Spanish (Latin America)"
      }, {
        code: "far",
        text: "Persian (Farsi)"
      }, {
        code: "fra",
        text: "French"
      }, {
        code: "gle",
        text: "Irish"
      }, {
        code: "grk",
        text: "Greek"
      }, {
        code: "heb",
        text: "Hebrew"
      }, {
        code: "hin",
        text: "Hindi"
      }, {
        code: "ind",
        text: "Indonesian"
      }, {
        code: "ita",
        text: "Italian"
      }, {
        code: "jpn",
        text: "Japanese"
      }, {
        code: "kis",
        text: "Swahili"
      }, {
        code: "kor",
        text: "Korean"
      }, {
        code: "lat",
        text: "Latin"
      }, {
        code: "ned",
        text: "Dutch"
      }, {
        code: "pas",
        text: "Pashto"
      }, {
        code: "pol",
        text: "Polish"
      }, {
        code: "por",
        text: "Portuguese (Brazil)"
      }, {
        code: "rus",
        text: "Russian"
      }, {
        code: "sve",
        text: "Swedish"
      }, {
        code: "tgl",
        text: "Filipino (Tagalog)"
      }, {
        code: "tur",
        text: "Turkish"
      }, {
        code: "urd",
        text: "Urdu"
      }, {
        code: "vie",
        text: "Vietnamese"
      }]
    },
    pg3: {
      success: "Success",
      enjoyPre: "Now that you're here, you can go anywhere. Please enjoy access to ",
      enjoyPost: " and the world's most renowned method for language learning.",
      explore: "START EXPLORING",
      allLanguages: "24 languages"
    }
  },
  "es-419": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "Empiece su aprendizaje ahora.",
      reqError: "Hubo un problema al procesar tu solicitud . Por favor, llame al: 1-800-ROSETTA para apoyo.",
      claimProdTypeErr: 'Este código de activación es para un programa de CD-ROM o Descarga digital. Para activar su producto, por favor siga <a href="//support.rosettastone.com/es/apprentissage-des-langues/articles/Activating-Rosetta-Stone-Version-4-TOTALe/search"> estás instrucciones.</a>',
      formDesc: 'Ingrese su código de activación. Búsquelo <a href="#" id="form-help-link">aquí.</a>',
      claimEmptyErr: "Por favor ingrese su código de activación.",
      claimInvalidActivationCodeErr: "Codigo de activación invalido.",
      claimAlreadyActivatedErr: "Su código de activación ya fue remedido.",
      claim500Err: 'Algo salió mal. Por favor comuníquese con el Equipo de <a href="//support.rosettastone.com/" target="_blank">Soporte Técnico</a>.',
      email: "E-mail (Su e-mail será su nombre de usuario)",
      emailErr: "Por favor ingrese un e-mail valido",
      terms: 'Al marcar esta casilla, usted acepta nuestras <a href="/termsonline">Condiciones de uso</a> y <a href="/privacy">Política de privacidad.</a>',
      termsErr: "Debe aceptar los Términos de uso",
      startActivationButton: "Inicie la activación",
      help: {
        h1: "¿Donde está mi código de activación?",
        boxedProducts: "Productos en caja",
        boxedProductsText: "Usted puede encontrar su código de activación en la tarjeta o folleto que se incluye con la caja.",
        gift: "Venta al por menor etiqueta colgante",
        giftText: "Usted puede encontrar su código de activación en la parte posterior de la tarjeta.",
        email: "Confirmación por e-mail",
        emailText: "Usted puede encontrar su código de activación en el e-mail de la confirmación de pedido.",
        conditions: "Los códigos de activación son una serie de caracteres alfanuméricos."
      }
    },
    pg2: {
      firstName: "Nombre",
      firstNameErr: "Por favor introduzca su primer nombre",
      lastName: "Apellido",
      lastNameErr: "Por favor introduzca su apellido",
      password: "Cree una contraseña",
      passwordErr: "Por favor ingrese contraseña",
      confirm: "Confirme la contraseña",
      confirmErr: "Por favor ingrese confirme la contraseña",
      matchErr: "Contraseñas no coinciden",
      show: "Mostrar contraseña",
      currencyLabel: "Para futuras transacciones",
      currency: "Seleccione Moneda",
      currencyErr: "Por favor seleccione una Moneda",
      supportLabel: "Por se caso necesitas ayuda",
      support: "Lenguaje de Soporte",
      supportErr: "Por favor seleccione su lenguaje de soporte",
      learningLabel: "¿Que le gustaría aprender?",
      learning: "Seleccionar un idioma de aprendizaje",
      learningErr: "Por favor seleccione su lenguaje de aprendizaje",
      singleLearning: "Usted aprenderá:",
      button: "Finalize la activación",
      processing: "Processing ...",
      amz: "Un usuario con esta dirección de correo electrónico ya tiene acceso a LANGUAGE_NAME mediante una suscripción de Amazon. Puede administrar su suscripción de Amazon <a href='AMAZON_LINK'>aquí.</a> Ingrese una dirección de correo electrónico alternativa, o escoja otro idioma que le gustaría aprender.",
      apple: "Un usuario con esta dirección de correo electrónico ya tiene acceso a LANGUAGE_NAME a través de la App Store de Apple. Ingrese una dirección de correo electrónico alternativa, o escoja otro idioma que le gustaría aprender.",
      google: "Un usuario con esta dirección de correo electrónico ya tiene acceso a LANGUAGE_NAME a través de la Google Play store. Ingrese una dirección de correo electrónico alternativa, o escoja otro idioma que le gustaría aprender.",
      mo: "Ahora ya tiene acceso a Learn Languages with Rosetta Stone mediante suscripción en línea a Rosetta Stone. Ingrese una dirección de correo electrónico alternativa, o seleccione otro idioma que le gustaría aprender.",
      hs: "Un usuario con esta dirección de correo electrónico tiene acceso a otra suscripción de Rosetta Stone. Ingrese una dirección de correo electrónico alternativa para activar y acceder a su producto Homeschool.",
      tsub: "Esta dirección de correo electrónico se ha utilizado anteriormente para activar y acceder al producto Homeschool. Ingrese una dirección de correo electrónico alternativa para continuar.",
      supportLanguages: ["Inglés", "Portugués", "Francés", "Italiano", "Japonés", "Español", "Alemán", "Coreano"],
      currencies: ["Dólar estadounidense ($)", "Yen (¥)", "Won (₩)", "GBP (£)", "Euro (€)"],
      learningLanguages: [{
        code: "all",
        text: "Todos los idiomas"
      }, {
        code: "ame",
        text: "Ingles (Americano)"
      }, {
        code: "ara",
        text: "Árabe"
      }, {
        code: "chi",
        text: "Chino (Mandarín)"
      }, {
        code: "dar",
        text: "Dari"
      }, {
        code: "deu",
        text: "Alemán"
      }, {
        code: "ebr",
        text: "Inglés (Británico)"
      }, {
        code: "ecs",
        text: "Espanol"
      }, {
        code: "eng",
        text: "Inglés (Americano)"
      }, {
        code: "esc",
        text: "Español (España)"
      }, {
        code: "esp",
        text: "Español (Latinoamérica)"
      }, {
        code: "far",
        text: "Persa (farsi)"
      }, {
        code: "fra",
        text: "Francés"
      }, {
        code: "gle",
        text: "Irlandés"
      }, {
        code: "grk",
        text: "Griego"
      }, {
        code: "heb",
        text: "Hebreo"
      }, {
        code: "hin",
        text: "Hindi"
      }, {
        code: "ind",
        text: "Indonesio"
      }, {
        code: "ita",
        text: "Italiano"
      }, {
        code: "jpn",
        text: "Japonés"
      }, {
        code: "kis",
        text: "Suajili"
      }, {
        code: "kor",
        text: "Coreano"
      }, {
        code: "lat",
        text: "Latín"
      }, {
        code: "ned",
        text: "Holandés"
      }, {
        code: "pas",
        text: "Pashto"
      }, {
        code: "pol",
        text: "Polaco"
      }, {
        code: "por",
        text: "Portugués (Brasil)"
      }, {
        code: "rus",
        text: "Ruso"
      }, {
        code: "sve",
        text: "Sueco"
      }, {
        code: "tgl",
        text: "Filipino (Tagalo)"
      }, {
        code: "tur",
        text: "Turco"
      }, {
        code: "urd",
        text: "Urdu"
      }, {
        code: "vie",
        text: "Vietnamita"
      }]
    },
    pg3: {
      success: "Éxito.",
      enjoyPre: "Ahora que llegó aquí, puede llegar donde quiera. Disfrute del acceso al ",
      enjoyPost: " y al método de aprendizaje de idiomas más reconocido del mundo.",
      explore: "COMIENCE A EXPLORAR",
      allLanguages: "24 idiomas"
    }
  },
  "ja-JP": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "学習を今すぐ開始",
      reqError: "There was an issue processing your request. Please call: 1-800-ROSETTA FREE for support.",
      claimProdTypeErr: 'このアクティベーションコードはCD-ROM版またはダウンロード版製品用のコードです。　製品をアクティブ化するには、<a href="//support.rosettastone.com/jp/language-learning/articles/Activating-Rosetta-Stone-Version-4-TOTALe">こちらの手順でお進み下さい。</a>',
      formDesc: 'アクティブ化コードを入力してください。<a href="#" id="form-help-link">ここで確認できます。</a>',
      claimEmptyErr: "アクティブ化コードを入力してください",
      claimInvalidActivationCodeErr: "無効のアクティブ化コード",
      claimAlreadyActivatedErr: "アクティブ化コードは既に登録されています。",
      claim500Err: '問題が発生しました。<a href="//support.rosettastone.com/" target="_blank">カスタマーサポー</a>トへ連絡してください。',
      email: "メールアドレス (これがユーザー名になります)",
      emailErr: "有効なメールアドレスを入力してください",
      terms: 'チェックを付けると、<a href="/termsonline">利用規約</a>および<a href="/privacy">プライバシー ポリシー</a>に同意したことになります。</label>',
      termsErr: "サービス規約に同意する必要があります",
      startActivationButton: "アクティブ化の開始",
      help: {
        h1: "アクティブ化コードはどこに記載されていますか？",
        boxedProducts: "ボックス製品",
        boxedProductsText: "アクティブ化コードは、パッケージに付属のカードまたは小冊子に記載されています。",
        gift: "リテイル ハングタグ",
        giftText: "アクティブ化コードは、カードの裏に記載されています。",
        email: "メール確認",
        emailText: "アクティブ化コードは、ご注文確認メールに記載されています。",
        conditions: "アクティブ化コードは、英数字で構成される一意の文字コードです。"
      }
    },
    pg2: {
      firstName: "名",
      firstNameErr: "名前を入力してください",
      lastName: "姓",
      lastNameErr: "苗字を入力してください",
      password: "パスワードの作成",
      passwordErr: "パスワードを入力してください",
      confirm: "パスワードの確認",
      confirmErr: "確認パスワードを入力してください",
      matchErr: "パスワードが一致しません",
      show: "パスワードの表示",
      currencyLabel: "そのほかのトランザクション<",
      currency: "通貨の選択",
      currencyErr: "通貨を選択してください",
      supportLabel: "お困りの際には",
      support: "サポート用言語",
      supportErr: "サポート用言語を選択してください",
      learningLabel: "何語を学習しますか？",
      learning: "学習言語を選択する",
      learningErr: "学習する言語を選択してください",
      singleLearning: "学習する言語:",
      button: "アクティブ化の完了",
      processing: "Processing ...",
      amz: "このメール アドレスのユーザーは、すでに Amazon の定期購読で LANGUAGE_NAME を利用しています。 Amazon の定期購読サービスは<a href='AMAZON_LINK'>ここで</a> 管理できます。 別のメール アドレスを入力するか、別の学習言語を選択してください。",
      apple: "このメールアドレスのユーザーは、すでに AppleのAppe Storeを通じて LANGUAGE_NAME にアクセスできます。別のメールアドレスを入力するか、別の学習言語を選択してください。",
      google: "このメールアドレスのユーザーは、すでに Google Play storeを通じて LANGUAGE_NAME にアクセスできます。別のメールアドレスを入力するか、別の学習言語を選択してください。",
      mo: "現時点では、すでに Rosetta Stone オンライン サブスクリプションによって Learn Languages with Rosetta Stone にアクセスできるようになっています。別のメール アドレスを入力するか、別の学習言語を選択してください。",
      hs: "Aこのメール アドレスのユーザーは、別の Rosetta Stone オンライン サービスを利用しています。Homeschool 製品をアクティブ化して利用するには、別のメール アドレスを入力してください。",
      tsub: "このメール アドレスは、すでに Homeschool 製品のアクティブ化と利用に使われています。続行するには、別のメール アドレスを入力してください。",
      supportLanguages: ["英語", "ポルトガル語(ブラジル)", "フランス語", "イタリア語", "日本語", "スペイン語(スペイン)", "ドイツ語", "韓国語"],
      currencies: ["ドル ($)", "円 (&yen;)", "ウォン (₩)", "ポンド (₤)", "ユーロ (&euro;)"],
      learningLanguages: [{
        code: "all",
        text: "全言語"
      }, {
        code: "ame",
        text: "英語（アメリカ）"
      }, {
        code: "ara",
        text: "アラビア語"
      }, {
        code: "chi",
        text: "中国語（マンダリン）"
      }, {
        code: "dar",
        text: "ダリー語"
      }, {
        code: "deu",
        text: "ドイツ語"
      }, {
        code: "ebr",
        text: "英語（イギリス）"
      }, {
        code: "ecs",
        text: "スペイン語(スペイン)"
      }, {
        code: "eng",
        text: "英語（アメリカ）"
      }, {
        code: "esc",
        text: "スペイン語(スペイン)"
      }, {
        code: "esp",
        text: "スペイン語（ラテンアメリカ）"
      }, {
        code: "far",
        text: "ペルシア語（ファルシ語）"
      }, {
        code: "fra",
        text: "フランス語"
      }, {
        code: "gle",
        text: "アイルランド語"
      }, {
        code: "grk",
        text: "ギリシャ語"
      }, {
        code: "heb",
        text: "ヘブライ語"
      }, {
        code: "hin",
        text: "ヒンディー語"
      }, {
        code: "ind",
        text: "インドネシア語"
      }, {
        code: "ita",
        text: "イタリア語"
      }, {
        code: "jpn",
        text: "日本語"
      }, {
        code: "kis",
        text: "スワヒリ語"
      }, {
        code: "kor",
        text: "韓国語"
      }, {
        code: "lat",
        text: "ラテン語"
      }, {
        code: "ned",
        text: "オランダ語"
      }, {
        code: "pas",
        text: "パシュトー語"
      }, {
        code: "pol",
        text: "ポーランド語"
      }, {
        code: "por",
        text: "ポルトガル語(ブラジル)"
      }, {
        code: "rus",
        text: "ロシア語"
      }, {
        code: "sve",
        text: "スウェーデン語"
      }, {
        code: "tgl",
        text: "フィリピン語(タガログ語)"
      }, {
        code: "tur",
        text: "トルコ語"
      }, {
        code: "urd",
        text: "ウルドゥー語"
      }, {
        code: "vie",
        text: "ベトナム語"
      }]
    },
    pg3: {
      success: "完了しました。",
      enjoyPre: "さあ、ここからどこへでも進むことができます。世界で最も定評ある言語学習メソッドで心ゆくまで",
      enjoyPost: "を学んでください。",
      explore: "探検を開始",
      allLanguages: "24 言語"
    }
  },
  "de-DE": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "Lernen Sie sofort.",
      reqError: "There was an issue processing your request. Please call: 1-800-ROSETTA FREE for support",
      claimProdTypeErr: 'Dieser Aktivierungscode ist für eine CD-ROM oder Download. Um Ihr Produkt zu aktivieren, folgen Sie bitte <a href="//support.rosettastone.com/de/erlernen-einer-sprache/articles/Activating-Rosetta-Stone-Version-4-TOTALe">den Anweisungen hier.</a>',
      formDesc: 'Bitte geben Sie Ihren Aktivierungscode ein. Diesen finden Sie <a href="#" id="form-help-link">hier.</a>',
      claimEmptyErr: "Bitte geben Sie Ihren Aktivierungscode ein.",
      claimInvalidActivationCodeErr: "Ungültiger Aktivierungscode.",
      claimAlreadyActivatedErr: "Ihr Aktivierungscode wurde schon eingegeben.",
      claim500Err: 'Etwas ist schief gelaufen.Bitte setzen Sie sich in Verbindung mit dem <a href="//support.rosettastone.com/" target="_blank">Support-Team</a>.',
      email: "E-mail Adresse (Ihre E-mail Adresse ist Ihr Benutzername)",
      emailErr: "Bitte geben Sie eine gültige E-mail Adresse ein",
      terms: 'Indem Sie dies ankreuzen, erklären Sie sich mit unseren <a href="/termsonline">Nutzungsbedingungen</a> und der <a href="/privacy">Datenschutzrichtlinie</a> einverstanden.',
      termsErr: "Sie müssen den rechtlichen Hinweisen zustimmen",
      startActivationButton: "Aktivierung starten",
      help: {
        h1: "Wo ist mein Aktivierungscode?",
        boxedProducts: "Paketversion",
        boxedProductsText: "Sie finden Ihren Aktivierungscode entweder auf einer Karte oder in der Broschüre, die sich innerhalb der Schachtel befindet.",
        gift: "Preisschild",
        giftText: "Sie finden Ihren Aktivierungscode auf der Rückseite Ihrer Karte.",
        email: "E-mail-Bestätigung",
        emailText: "Sie finden Ihren Aktivierungscode in Ihrer Bestätigungsmail.",
        conditions: "Aktivierungscodes sind alphanumerische Zeichenketten."
      }
    },
    pg2: {
      firstName: "Vorname",
      firstNameErr: "Bitte geben Sie Ihren Vornamen ein",
      lastName: "Nachname",
      lastNameErr: "Bitte geben Sie Ihren Nachnamen ein",
      password: "Passwort erstellen",
      passwordErr: "Bitte Passwort eingeben",
      confirm: "Passwort bestätigen",
      confirmErr: "Bitte Bestätigungspasswort eingeben",
      matchErr: "Passwörter stimmen nicht überein",
      show: "Kennwort anzeigen",
      currencyLabel: "Für zukünftige Transaktionen",
      currency: "Währung auswählen",
      currencyErr: "Bitte wählen Sie eine Währung aus",
      supportLabel: "Falls Sie unsere Hilfe brauchen",
      support: "Supportsprache",
      supportErr: "Bitte wählen Sie eine Supportsprache aus",
      learningLabel: "Was möchten Sie lernen?",
      learning: "Lernsprache auswählen",
      learningErr: "Bitte wählen Sie eine Sprache zum Lernen aus",
      singleLearning: "Sie lernen:",
      button: "Aktivierung abschließen",
      processing: "Processing ...",
      amz: "Ein Benutzer mit dieser E-Mail-Adresse hat bereits über Amazon-Abonnements Zugriff auf LANGUAGE_NAME. Sie können Ihr Amazon-Abonnement <a href='AMAZON_LINK'> hier verwalten.</a> Bitte geben Sie eine alternative E-Mail-Adresse ein oder wählen Sie eine andere Sprache aus, die Sie lernen möchten.",
      apple: "Ein Benutzer mit dieser E-Mail-Adresse hat bereits über Zugriff auf LANGUAGE_NAME über den Apple App-Store. Bitte geben Sie eine alternative E-Mail-Adresse ein oder wählen Sie eine andere Sprache aus, die Sie lernen möchten.",
      google: "Ein Benutzer mit dieser E-Mail-Adresse hat bereits über Zugriff auf LANGUAGE_NAME über den Google Play store. Bitte geben Sie eine alternative E-Mail-Adresse ein oder wählen Sie eine andere Sprache aus, die Sie lernen möchten.",
      mo: 'Derzeit haben Sie über Ihr Rosetta Stone-Online-Abonnement bereits Zugriff auf das Programm „Learn Languages with Rosetta Stone". Bitte geben Sie eine alternative E-Mail-Adresse ein oder wählen Sie eine andere Sprache aus, die Sie lernen möchten.',
      hs: "Ein Benutzer mit dieser E-Mail-Adresse hat Zugriff auf ein anderes Rosetta Stone-Abonnement. Bitte geben Sie eine alternative E-Mail-Adresse ein, um Ihr Homeschool-Produkt zu aktivieren und auf dieses zuzugreifen.",
      tsub: "Diese E-Mail-Adresse wurde zuvor zum Aktivieren und zum Zugriff auf das Homeschool-Produkt verwendet. Bitte geben Sie eine alternative E-Mail-Adresse ein, um fortzufahren.",
      supportLanguages: ["Englisch", "Portugiesisch", "Französisch", "Italienisch", "Japanisch", "Spanisch", "Deutsch", "Koreanisch"],
      currencies: ["Dollar ($)", "Yen (¥)", "Won (₩)", "GBP (£)", "Euro (€)"],
      learningLanguages: [{
        code: "all",
        text: "Alle Sprachen"
      }, {
        code: "ame",
        text: "Englisch (Amerikanisch)"
      }, {
        code: "ara",
        text: "Arabisch"
      }, {
        code: "chi",
        text: "Chinesisch (Mandarin)"
      }, {
        code: "dar",
        text: "Dari"
      }, {
        code: "deu",
        text: "Deutsch"
      }, {
        code: "ebr",
        text: "Englisch (Britisch)"
      }, {
        code: "ecs",
        text: "Spanisch"
      }, {
        code: "eng",
        text: "Englisch (Amerikanisch)"
      }, {
        code: "esc",
        text: "Spanisch (Spanien)"
      }, {
        code: "esp",
        text: "Spanisch (Lateinamerika)"
      }, {
        code: "far",
        text: "Persisch (Farsi)"
      }, {
        code: "fra",
        text: "Französisch"
      }, {
        code: "gle",
        text: "Irisch"
      }, {
        code: "grk",
        text: "Griechisch"
      }, {
        code: "heb",
        text: "Hebräisch"
      }, {
        code: "hin",
        text: "Hindi"
      }, {
        code: "ind",
        text: "Indonesian"
      }, {
        code: "ita",
        text: "Italienisch"
      }, {
        code: "jpn",
        text: "Japanisch"
      }, {
        code: "kis",
        text: "Swahili"
      }, {
        code: "kor",
        text: "Koreanisch"
      }, {
        code: "lat",
        text: "Latin"
      }, {
        code: "ned",
        text: "Niederländisch"
      }, {
        code: "pas",
        text: "Pashto"
      }, {
        code: "pol",
        text: "Polnisch"
      }, {
        code: "por",
        text: "Portugiesisch (Brasilien)"
      }, {
        code: "rus",
        text: "Russisch"
      }, {
        code: "sve",
        text: "Schwedisch"
      }, {
        code: "tgl",
        text: "Philippinisch (Tagalog)"
      }, {
        code: "tur",
        text: "Türkisch"
      }, {
        code: "urd",
        text: "Urdu"
      }, {
        code: "vie",
        text: "Vietnamesisch"
      }]
    },
    pg3: {
      success: "Erfolg.",
      enjoyPre: "Von hier aus können Sie nun überallhin gehen. Wir wünschen Ihnen viel Freude beim Zugang zu ",
      enjoyPost: " und der bewährtesten Methode der Welt, Sprachen zu erlernen.",
      explore: "MIT DER ERKUNDUNG BEGINNEN",
      allLanguages: "24 Sprachen"
    }
  },
  "it-IT": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "Inizia ad apprendere ora.",
      reqError: "There was an issue processing your request. Please call: 1-800-ROSETTA FREE for support.",
      claimProdTypeErr: 'Questo codice di attivazione é inteso per un prodotto CD-Rom o Download Digitale. Per attivare il tuo prodotto, ti preghiamo di seguire le <a href="//support.rosettastone.com/it/Apprendimentolinguistico/articles/Activating-Rosetta-Stone-Version-4-TOTALe">istruzioni riportate di seguito.</a>',
      formDesc: 'Inserisci il codice di attivazione. Lo trovi <a href="#" id="form-help-link">qui.</a>',
      claimEmptyErr: "Prego inserisca la chiave di attivazione.",
      claimInvalidActivationCodeErr: "Codice di attivazione non valido.",
      claimAlreadyActivatedErr: "La sua chiave di attivazione e' gia' stata attivata.",
      claim500Err: 'Qualcosa e\' andato storto. Si prega di contattare il <a href="//support.rosettastone.com/" target="_blank">servizio di assistenza al prodotto</a>.',
      email: "Casella di posta elettronica (Ihre E-mail Adresse ist Ihr Benutzername)",
      emailErr: "Prego inserisca una casella di posta elettronica attiva",
      terms: 'Selezionando questa casella, accetti le nostre <a href="/termsonline">Condizioni d\'utilizzo</a> e la <a href="/privacy">Normativa sulla privacy</a>.',
      termsErr: "È necessario accettare le Condizioni del servizio",
      startActivationButton: "Inizia l'attivazione",
      help: {
        h1: "Dove trovo la mia chiave di attivazione?",
        boxedProducts: "Prodotti all'interno della confezione",
        boxedProductsText: "Può trovare il codice di attivazione sulla carta o sul libretto incluso nella sua scatola.",
        gift: "Buono regalo",
        giftText: "YPuò trovare il codice di attivazione sul retro della sua carta.",
        email: "E-mail di conferma",
        emailText: "Può trovare il codice di attivazione nella email contenente la conferma del suo ordine.",
        conditions: "I codici di attivazione consistono in una stringa alfanumerica."
      }
    },
    pg2: {
      firstName: "Nome",
      firstNameErr: "Prego inserisca il suo nome",
      lastName: "Cognome",
      lastNameErr: "Prego inserisca il suo cognome",
      password: "Crea password",
      passwordErr: "Per favore, inserisci la password",
      confirm: "Conferma password",
      confirmErr: "Inserisci la password di conferma",
      matchErr: "La password non corrisponde",
      show: "Mostra password",
      currencyLabel: "Per future transazioni",
      currency: "Selezioni la valuta",
      currencyErr: "Seleziona una valuta",
      supportLabel: "In caso lei abbia bisogno di aiuto",
      support: "Lingua di supporto",
      supportErr: "Prego selezioni la lingua di supporto",
      learningLabel: "Cosa le piacerebbe apprendere?",
      learning: "Seleziona una lingua studiata",
      learningErr: "Prego selezioni la lingua da apprendere",
      singleLearning: "Lei apprenderà:",
      button: "Termina attivazione",
      processing: "Processing ...",
      amz: "Un utente con questo indirizzo e-mail ha accesso alla lingua LANGUAGE_NAME tramite gli abbonamenti Amazon. Puoi gestire <a href='AMAZON_LINK'>qui</a> il tuo abbonamento Amazon. Immetti un indirizzo e-mail alternativo o seleziona un'altra lingua che desideri apprendere.",
      apple: "Un utente con questo indirizzo e-mail ha accesso alla lingua LANGUAGE_NAME tramite l'App Store della Apple. Immetti un indirizzo e-mail alternativo o seleziona un'altra lingua che desideri apprendere.",
      google: "Un utente con questo indirizzo e-mail ha accesso alla lingua LANGUAGE_NAME tramite Google Play store. Immetti un indirizzo e-mail alternativo o seleziona un'altra lingua che desideri apprendere.",
      mo: "Hai già accesso a Learn Languages with Rosetta Stone tramite il tuo abbonamento online a Rosetta Stone. Immetti un indirizzo e-mail alternativo o seleziona un'altra lingua che desideri apprendere.",
      hs: "Un utente con questo indirizzo e-mail ha accesso a un altro abbonamento Rosetta Stone. Immetti un indirizzo e-mail alternativo per attivare e accedere al prodotto Homeschool.",
      tsub: "Questo indirizzo e-mail è stato già usato per attivare e accedere al prodotto Homeschool. Immetti un indirizzo e-mail alternativo per continuare.",
      supportLanguages: ["Inglese", "Portoghese", "Francese", "Italiano", "Giapponese", "Spagnolo", "Tedesco", "Coreano"],
      currencies: ["Dollaro Statunitense ($)", "Yen (¥)", "Won (₩)", "Sterlina inglese (£)", "Euro (€)"],
      learningLanguages: [{
        code: "all",
        text: "Tutte le lingue"
      }, {
        code: "ame",
        text: "Inglese (Americano)"
      }, {
        code: "ara",
        text: "Arabo"
      }, {
        code: "chi",
        text: "Cinese (Mandarino)"
      }, {
        code: "dar",
        text: "Dari"
      }, {
        code: "deu",
        text: "Tedesco"
      }, {
        code: "ebr",
        text: "Inglese (Britannico)"
      }, {
        code: "ecs",
        text: "Spagnolo"
      }, {
        code: "eng",
        text: "Inglese (Americano)"
      }, {
        code: "esc",
        text: "Spagnolo (Spagna)"
      }, {
        code: "esp",
        text: "Spagnolo (America Latina)"
      }, {
        code: "far",
        text: "Persiano (Farsi)"
      }, {
        code: "fra",
        text: "Francese"
      }, {
        code: "gle",
        text: "Irlandese"
      }, {
        code: "grk",
        text: "Greco"
      }, {
        code: "heb",
        text: "Ebraico"
      }, {
        code: "hin",
        text: "Hindi"
      }, {
        code: "ind",
        text: "Indonesian"
      }, {
        code: "ita",
        text: "Italiano"
      }, {
        code: "jpn",
        text: "Giapponese"
      }, {
        code: "kis",
        text: "Swahili"
      }, {
        code: "kor",
        text: "Coreano"
      }, {
        code: "lat",
        text: "Latin"
      }, {
        code: "ned",
        text: "Olandese"
      }, {
        code: "pas",
        text: "Pashto"
      }, {
        code: "pol",
        text: "Polacco"
      }, {
        code: "por",
        text: "Portoghese (Brasile)"
      }, {
        code: "rus",
        text: "Russo"
      }, {
        code: "sve",
        text: "Svedese"
      }, {
        code: "tgl",
        text: "Tagalog (Filippino)"
      }, {
        code: "tur",
        text: "Turco"
      }, {
        code: "urd",
        text: "Urdu"
      }, {
        code: "vie",
        text: "Vietnamita"
      }]
    },
    pg3: {
      success: "Procedura completata.",
      enjoyPre: "Ora che sei arrivato qui, puoi andare ovunque. Approfitta dell'accesso a ",
      enjoyPost: " e del metodo più rinomato al mondo per imparare le lingue.",
      explore: "INIZIA L'ESPLORAZIONE",
      allLanguages: "24 lingue"
    }
  },
  "ko-KR": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "지금 학습을 시작하십시오.",
      reqError: "There was an issue processing your request. Please call: 1-800-ROSETTA FREE for support.",
      claimProdTypeErr: '활성화 코드는 CD-ROM이나 다운로드 제품을 위해 사용됩니다. 제품을 활성화하시려면, <a href="//support.rosettastone.com/kr/language-learning/articles/Activating-Rosetta-Stone-Version-4-TOTALe">다음의 지시사항에 따라주세요.</a>',
      formDesc: '활성화 코드를 입력하세요.<a href="#" id="form-help-link">여기</a>서 찾으세요.',
      claimEmptyErr: "활성화 코드를 입력해주세요",
      claimInvalidActivationCodeErr: "유효하지 않은 활성화 코드",
      claimAlreadyActivatedErr: "활성화 코드가 이미 소진되었습니다.",
      claim500Err: '잠시 문제가 생겼습니다. <a href="//support.rosettastone.com/" target="_blank">기술 지원</a> 팀에 문의해주세요.',
      email: "이메일 주소 (이것은 아이디가 됩니다)",
      emailErr: "올바른 형식의 이메일을 입력해주세요.",
      terms: '여기에 체크하시면, 당사의 <a href="/termsonline">이용약관</a> 및 <a href="/privacy">개인정보 보호 정책</a>에 동의하신 것을 의미합니다.',
      termsErr: "서비스 약관에 동의하셔야 합니다",
      startActivationButton: "활성화 시작<",
      help: {
        h1: "활성화 코드를 어디서 확인할 수 있나요?",
        boxedProducts: "박스 제품",
        boxedProductsText: "활성화 코드는 박스에 포함된 카드 또는 북릿(booklet:소책자)에서 찾으실 수 있습니다.",
        gift: "리테일 행 태그",
        giftText: "활성화 코드를 카드의 뒷 면에서 찾으실 수 있습니다.",
        email: "주문 확인서 이메일",
        emailText: "활성화 코드를 주문 확인서 이메일에서 찾으실 수 있습니다.",
        conditions: "활성화 코드는 영어 알파벳과 숫자 조합으로 이루어져 있습니다."
      }
    },
    pg2: {
      firstName: "이름 (First Name)",
      firstNameErr: "고객님의 이름을 입력해주세요. (성 제외)",
      lastName: "성 (Last Name)",
      lastNameErr: "고객님의 성을 입력해주세요.",
      password: "비밀번호",
      passwordErr: "암호를 입력하십시오.",
      confirm: "비밀번호 재확인",
      confirmErr: "암호 확인을 입력하십시오.",
      matchErr: "비밀번호가 일치하지 않습니다.",
      show: "비밀번호를 잊으셨습니까?",
      currencyLabel: "향후 주문시",
      currency: "통화를 선택하십시오.",
      currencyErr: "통화를 선택하십시오.",
      supportLabel: "도움이 필요하실 경우",
      support: "지원 언어",
      supportErr: "지원 언어를 선택해주세요.",
      learningLabel: "배우고자 하는 외국어를 선택해주세요.",
      learning: "학습 언어 선택",
      learningErr: "배우고자 하는 외국어를 다음의 항목 중에 선택해주세요.",
      singleLearning: "고객님이 학습하실 외국어는 다음과 같습니다:",
      button: "활성화를 완료",
      processing: "Processing ...",
      amz: "이 이메일 주소 사용자는 Amazon 수강권으로만 LANGUAGE_NAME 에 접속할 수 있습니다. Amazon 수강권을 <a href='AMAZON_LINK'>여기</a> 에서 처리할 수 있으니 다른 이메일 주소를 입력하거나, 아니면 학습하고자 하는 다른 언어를 선택하세요.",
      apple: "해당 이메일 주소를 가진 사용자는 이미 Apple 사의 App Store를 통해서 LANGUAGE_NAME 에 액세스 할 수 있습니다. 다른 이메일 주소를 입력하거나, 아니면 학습하고자 하는 다른 언어를 선택하세요.",
      google: "해당 이메일 주소를 가진 사용자는 이미 Google Play store를 통해서 LANGUAGE_NAME 에 액세스 할 수 있습니다. 다른 이메일 주소를 입력하거나, 아니면 학습하고자 하는 다른 언어를 선택하세요.",
      mo: "Rosetta Stone Online Subscription을 통해 Learn Languages with Rosetta Stone 에 이미 접속 권한이 있습니다. 다른 이메일 주소를 입력하거나 학습하고자 하는 다른 언어를 선택해 주세요.",
      hs: "이 이메일 주소는 이미 다른 Rosetta Stone 제품에 사용 중입니다. 대체 이메일 주소를 입력 하여 Homeschool 제품을 화성화하시기 바랍니다.",
      tsub: "이 이메일 주소는 이전에 Homeschool 제품을 활성화하고 액세스하는 데 사용되었습니다. 계속하려면 다른 이메일 주소를 입력하세요.",
      supportLanguages: ["영어", "포르투갈어 (브라질)", "프랑스어", "이탈리아어", "일본어", "스페인어", "독일어", "한국어"],
      currencies: ["미국 달러 (USD)", "일본 엔 (YEN)", "원 (KRW)", "영국 파운드 (GBP)", "유럽 유로 (EUR)"],
      learningLanguages: [{
        code: "all",
        text: "모든 언어"
      }, {
        code: "ame",
        text: "영어 (미국)"
      }, {
        code: "ara",
        text: "아랍어"
      }, {
        code: "chi",
        text: "중국어 (만다린)"
      }, {
        code: "dar",
        text: "다리어"
      }, {
        code: "deu",
        text: "독일어"
      }, {
        code: "ebr",
        text: "영어 (영국)"
      }, {
        code: "ecs",
        text: "스페인어 (스페인)"
      }, {
        code: "eng",
        text: "영어 (미국)"
      }, {
        code: "esc",
        text: "스페인어 (스페인)"
      }, {
        code: "esp",
        text: "스페인어 (라틴아메리카)"
      }, {
        code: "far",
        text: "페르시아어"
      }, {
        code: "fra",
        text: "프랑스어"
      }, {
        code: "gle",
        text: "아일랜드어"
      }, {
        code: "grk",
        text: "그리스어"
      }, {
        code: "heb",
        text: "히브리어"
      }, {
        code: "hin",
        text: "힌디어"
      }, {
        code: "ind",
        text: "인도네시아어"
      }, {
        code: "ita",
        text: "이탈리아어"
      }, {
        code: "jpn",
        text: "일본어"
      }, {
        code: "kis",
        text: "스와힐리어"
      }, {
        code: "kor",
        text: "한국어"
      }, {
        code: "lat",
        text: "라틴어"
      }, {
        code: "ned",
        text: "네덜란드어"
      }, {
        code: "pas",
        text: "파슈토어"
      }, {
        code: "pol",
        text: "폴란드어"
      }, {
        code: "por",
        text: "포르투갈어 (브라질)"
      }, {
        code: "rus",
        text: "러시아어"
      }, {
        code: "sve",
        text: "스웨덴어"
      }, {
        code: "tgl",
        text: "필리핀어 (타갈로그어)"
      }, {
        code: "tur",
        text: "터키어"
      }, {
        code: "urd",
        text: "우르두어"
      }, {
        code: "vie",
        text: "베트남어"
      }]
    },
    pg3: {
      success: "환영합니다.",
      enjoyPre: "여기 오신 이상, 어디든지 가실 수 있습니다. ",
      enjoyPost: "를 선택하여 세계에서 가장 유명한 언어 학습법을 체험해 보세요.",
      explore: "탐색 시작",
      allLanguages: "24개 언어"
    }
  },
  "fr-FR": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "Commencez votre apprentissage dès maintenant.",
      reqError: "There was an issue processing your request. Please call: 1-800-ROSETTA FREE for support",
      claimProdTypeErr: 'Ce code d\'activation est pour les CD-ROMs ou le téléchargement du produit.Pour activer votre produit, suivez les <a href="//support.rosettastone.com/fr/apprentissage-des-langues/articles/Activating-Rosetta-Stone-Version-4-TOTALe">instructions ci-dessou.</a>',
      formDesc: 'Veuillez entrer votre code d\'activation. Vous le trouverez <a href="#" id="form-help-link">ici.</a>',
      claimEmptyErr: "Entrez votre Code d'Activation s'il vous plait.",
      claimInvalidActivationCodeErr: "Code d'activation invalide.",
      claimAlreadyActivatedErr: "Votre code d'activation a déjà été utilisé.",
      "3claim500Err": 'Une erreur s\'est produite. Veuillez contacter l\'équipe de <a href="//support.rosettastone.com/" target="_blank">support technique</a>.',
      email: "Addresse e-mail (Votre adresse email sera votre nom d'utilisateur)",
      emailErr: "S'il vous plaît entrer une adresse email valide",
      terms: 'En cochant cette case, vous acceptez nos <a href="//www.rosettastone.com/termsonline">conditions d\'utilisation</a> et notre <a href="//www.rosettastone.com/interactiveproductprivacy">politique de confidentialité</a>.',
      termsErr: "Vous devez accepter les conditions d'utilisation",
      startActivationButton: "Commencez l'Activation",
      help: {
        h1: "Ou se trouve mon code d'activation?",
        boxedProducts: "produits coffrets",
        boxedProductsText: "Vous pouvez trouver votre code d'activation sur la carte ou dans le livret qui est inclus dans votre boîte.",
        gift: "Vente au détail de l'etiquette suspendu",
        giftText: "Vous pouvez trouver votre code d'activation sur le verso de votre carte.",
        email: "Confirmation d'email",
        emailText: "Vous pouvez trouver votre code d'activation dans votre confirmation de commande par e-mail.",
        conditions: "Les codes d'activation sont une chaîne de caractères alphanumériques."
      }
    },
    pg2: {
      firstName: "Prénom",
      firstNameErr: "Entrez votre prénom s'il vous plaît",
      lastName: "Nom de Famille",
      lastNameErr: "Entrez votre nom de famille s'il vous plaît",
      password: "Créer un mot de passe",
      passwordErr: "Veuillez entrer le mot de passe",
      confirm: "Confirmez le mot de passe",
      confirmErr: "Entrez le mot de passe de confirmation",
      matchErr: "Les mots de passe ne correspondent pas",
      show: "Afficher le mot de passe",
      currencyLabel: "Pour des transactions dans l'avenir",
      currency: "Choisissez une monnaie",
      currencyErr: "Sélectionnez une monnaie",
      supportLabel: "Juste au cas où vous avez besoin d'aide",
      support: "Support linguistique",
      supportErr: "Sélectionnez une langue de support s'il vous plaît",
      learningLabel: "Que desirez-vous apprendre?",
      learning: "Sélectionner une langue d'apprentissage",
      learningErr: "Sélectionnez une langue à apprendre s'il vous plaît",
      singleLearning: "Vous allez apprendre:",
      button: "Terminer l'activation",
      processing: "Processing ...",
      amz: "Un utilisateur avec cette adresse e-mail a déjà accès à LANGUAGE_NAME via les abonnements Amazon. Vous pouvez gérer votre abonnement Amazon <a href='AMAZON_LINK'>ici.</a>Veuillez entrer une autre adresse e-mail ou sélectionner une autre langue que vous aimeriez apprendre.",
      apple: "Un utilisateur avec cette adresse e-mail a déjà accès à LANGUAGE_NAME à travers le App Store par Apple. Veuillez entrer une autre adresse e-mail ou sélectionner une autre langue que vous aimeriez apprendre.",
      google: "Un utilisateur avec cette adresse e-mail a déjà accès à LANGUAGE_NAME à travers le Google Play store. Veuillez entrer une autre adresse e-mail ou sélectionner une autre langue que vous aimeriez apprendre.",
      mo: "Vous avez déjà accès à Learn Languages with Rosetta Stone via votre abonnement en ligne Rosetta Stone. Veuillez entrer une autre adresse e-mail ou sélectionner une autre langue que vous aimeriez apprendre.",
      hs: "Un utilisateur avec cette adresse e-mail a accès à un autre abonnement Rosetta Stone. Veuillez entrer une autre adresse e-mail pour activer et accéder à votre produit Homeschool.",
      tsub: "Cette adresse e-mail a été utilisée précédemment pour activer et accéder au produit Homeschool. Veuillez entrer une autre adresse e-mail pour continuer.",
      supportLanguages: ["Anglais", "Portugais", "Français", "Italien", "Japonais", "Espagnol", "Allemand", "Coréen"],
      currencies: ["USD ($)", "Yen (¥)", "Won (₩)", "Livres sterling (£)", "Euro (€)"],
      learningLanguages: [{
        code: "all",
        text: "Toutes les langues"
      }, {
        code: "ame",
        text: "Anglais (Americain)"
      }, {
        code: "ara",
        text: "Arabe"
      }, {
        code: "chi",
        text: "Chinois (Mandarin)"
      }, {
        code: "dar",
        text: "Dari"
      }, {
        code: "deu",
        text: "Allemand"
      }, {
        code: "ebr",
        text: "Anglais (Britannique)"
      }, {
        code: "ecs",
        text: "Espagnol"
      }, {
        code: "eng",
        text: "Anglais (Américain)"
      }, {
        code: "esc",
        text: "Espagnol (Espagne)"
      }, {
        code: "esp",
        text: "Espagnol (Amérique Latine)"
      }, {
        code: "far",
        text: "Persan (Farsi)"
      }, {
        code: "fra",
        text: "Français"
      }, {
        code: "gle",
        text: "Irlandais"
      }, {
        code: "grk",
        text: "Grec"
      }, {
        code: "heb",
        text: "Hébreu"
      }, {
        code: "hin",
        text: "Hindi"
      }, {
        code: "ind",
        text: "Indonesian"
      }, {
        code: "ita",
        text: "Italien"
      }, {
        code: "jpn",
        text: "Japonais"
      }, {
        code: "kis",
        text: "Swahili"
      }, {
        code: "kor",
        text: "Coréen"
      }, {
        code: "lat",
        text: "Latin"
      }, {
        code: "ned",
        text: "Néerlandais"
      }, {
        code: "pas",
        text: "Pashto"
      }, {
        code: "pol",
        text: "Polonais"
      }, {
        code: "por",
        text: "Portugais (Brésil)"
      }, {
        code: "rus",
        text: "Russe"
      }, {
        code: "sve",
        text: "Suédois"
      }, {
        code: "tgl",
        text: "Tagalog"
      }, {
        code: "tur",
        text: "Turc"
      }, {
        code: "urd",
        text: "Urdu"
      }, {
        code: "vie",
        text: "Vietnamien"
      }]
    },
    pg3: {
      success: "Succès !",
      enjoyPre: "Maintenant que vous êtes là, vous pouvez aller n'importe où. Profitez d'un accès à la langue : ",
      enjoyPost: " et à la méthode d'apprentissage linguistique la plus réputée au monde.",
      explore: "DÉMARRER L'EXPLORATION",
      allLanguages: "24 langues"
    }
  },
  "pt-BR": {
    pg1: {
      bannerImg: "Phones fanning out",
      bannerHdr: "Comece a aprender agora mesmo.",
      reqError: "There was an issue processing your request. Please call: 1-800-ROSETTA FREE for support",
      claimProdTypeErr: 'Este código de ativação é para um programa CD-ROM ou download digital. Para ativar o produto, por favor <a href="//support.rosettastone.com/pt/linguagem-aprendizagem/articles/Activating-Rosetta-Stone-Version-4-TOTALe">siga estas instruções.</a>',
      formDesc: 'Digite seu código de ativação. Encontre-o <a href="#" id="form-help-link">aqui.</a>',
      claimEmptyErr: "Por favor, insira o código de ativação",
      claimInvalidActivationCodeErr: "Código de ativação inválido.",
      claimAlreadyActivatedErr: "Seu código de ativação já foi resgatado.",
      claim500Err: 'Algo deu errado. Entre em contato com a equipe de <a href="//support.rosettastone.com/" target="_blank">suporte do produto</a>.',
      email: "E-mail (O seu endereço de e-mail será o seu nome de usuário)",
      emailErr: "Por favor insira um endereço de e-mail válido",
      terms: 'Ao marcar esta caixa, você concorda com nossos <a href="/termsonline">Termos de uso</a> e com nossas <a href="/privacy">Regras de privacidade</a>.',
      termsErr: "É necessário aceitar os Termos de Uso",
      startActivationButton: "Comece a Ativação",
      help: {
        h1: "Onde está o meu código de ativação?",
        boxedProducts: "Produto na Caixa",
        boxedProductsText: "Você pode encontrar o código de ativação no cartão ou folheto que vem incluído na sua caixa.",
        gift: "Versão varejo do produto",
        giftText: "Você pode encontrar o código de ativação no verso do seu cartão.",
        email: "Email de confirmação",
        emailText: "Você pode encontrar o código de ativação no email de confirmação do seu pedido.",
        conditions: "Os códigos de ativação são uma seqüência de caracteres alfanuméricos."
      }
    },
    pg2: {
      firstName: "Primeiro Nome",
      firstNameErr: "Digite seu primeiro nome",
      lastName: "Sobrenome",
      lastNameErr: "Digite seu sobrenome",
      password: "Criar senha",
      passwordErr: "Digite a senha",
      confirm: "Confirme sua senha",
      confirmErr: "Digite a senha de confirmação",
      matchErr: "Senhas não conferem",
      show: "Mostrar senha",
      currencyLabel: "Para as transações futuras",
      currency: "Selecione a moeda",
      currencyErr: "Selecione uma moeda",
      supportLabel: "Em caso de você precisar de nossa ajuda",
      support: "Idioma de Suporte",
      supportErr: "Please select a support language",
      learningLabel: "O que você gostaria de aprender?",
      learning: "Selecionar idioma de aprendizado",
      learningErr: "Por favor, selecione o idioma que deseja aprender",
      singleLearning: "Você estará aprendendo:",
      button: "Conclua a ativação",
      processing: "Processing ...",
      amz: "Um usuário com este mesmo endereço de email já tem acesso ao LANGUAGE_NAME por meio das assinaturas da Amazon. Você pode gerenciar sua assinatura da Amazon <a href='AMAZON_LINK'>aqui.</a> Insira um endereço de email alternativo ou selecione outro idioma que você gostaria de aprender.",
      apple: "Um usuário com este mesmo endereço de email já tem acesso ao LANGUAGE_NAME através da App Store pela Apple. Insira um endereço de email alternativo ou selecione outro idioma que você gostaria de aprender.",
      google: "Um usuário com este mesmo endereço de email já tem acesso ao LANGUAGE_NAME através da Google Play store. Insira um endereço de email alternativo ou selecione outro idioma que você gostaria de aprender.",
      mo: "No momento, você já tem acesso ao aplicativo Learn Languages with Rosetta Stone por meio de sua assinatura do Rosetta Stone Online. Insira um endereço de email alternativo ou selecione outro idioma que você gostaria de aprender.",
      hs: "Um usuário com este mesmo endereço de email já tem acesso a outra assinatura do Rosetta Stone. Digite um endereço de email alternativo para ativar e acessar seu produto Homeschool.",
      tsub: "Este endereço de email já foi utilizado anteriormente para ativar e acessar o produto Homeschool. Digite um endereço de email alternativo para continuar.",
      supportLanguages: ["Inglês", "Portuguese", "Francês", "Italiano", "Japonês", "Espanhol", "Alemão", "Coreano"],
      currencies: ["Dolár Americano ($)", "Iene (¥)", "Won (₩)", "Libra Esterlina (£)", "Euro (€)"],
      learningLanguages: [{
        code: "all",
        text: "Todas as línguas"
      }, {
        code: "ame",
        text: "Ingles (Americano)"
      }, {
        code: "ara",
        text: "Arabe"
      }, {
        code: "chi",
        text: "Chines (mandarim)"
      }, {
        code: "dar",
        text: "Dari"
      }, {
        code: "deu",
        text: "Alemao"
      }, {
        code: "ebr",
        text: "Ingles (britanico)"
      }, {
        code: "ecs",
        text: "Espanhol"
      }, {
        code: "eng",
        text: "Ingles (americano)"
      }, {
        code: "esc",
        text: "Espanhol (Espanha)"
      }, {
        code: "esp",
        text: "Espanhol (America Latina)"
      }, {
        code: "far",
        text: "Persa (Farsi)"
      }, {
        code: "fra",
        text: "Frances"
      }, {
        code: "gle",
        text: "Irlandes"
      }, {
        code: "grk",
        text: "Grego"
      }, {
        code: "heb",
        text: "Hebraico"
      }, {
        code: "hin",
        text: "Hindi"
      }, {
        code: "ind",
        text: "Indonesio"
      }, {
        code: "ita",
        text: "Italiano"
      }, {
        code: "jpn",
        text: "Japones"
      }, {
        code: "kis",
        text: "Suaile"
      }, {
        code: "kor",
        text: "Coreano"
      }, {
        code: "lat",
        text: "Latim"
      }, {
        code: "ned",
        text: "Holandes"
      }, {
        code: "pas",
        text: "Pachto"
      }, {
        code: "pol",
        text: "Polones"
      }, {
        code: "por",
        text: "Portugues (Brasil)"
      }, {
        code: "rus",
        text: "Russo"
      }, {
        code: "sve",
        text: "Sueco"
      }, {
        code: "tgl",
        text: "Filipino (tagalo)"
      }, {
        code: "tur",
        text: "Turco"
      }, {
        code: "urd",
        text: "Urdu"
      }, {
        code: "vie",
        text: "Vietnamita"
      }]
    },
    pg3: {
      success: "Sucesso.",
      enjoyPre: "Agora que você está aqui, poderá ir a qualquer lugar. Aproveite o acesso ao ",
      enjoyPost: " e ao método de aprendizado de idiomas mais renomado do mundo.",
      explore: "COMEÇAR A EXPLORAR",
      allLanguages: "24 idiomas"
    }
  }
};

var productActivationConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeRoot: storeRoot$4,
  currencyMap: currencyMap,
  translations: translations
});

var initialState = {
  shortLocale: "",
  // e
  localeBase: null,
  // translations["en-US"]
  config: null,
  // PAGE ONE
  isSubmitting: false,
  idPart1: "",
  idPart2: "",
  idPart3: "",
  idError: "",
  emailAddress: "",
  emailAddressError: "",
  termsAccepted: false,
  termsAcceptedError: "",
  apiError: "",
  // NOTE: the following are all string values
  vendor: "",
  productType: "",
  firstName: "",
  lastName: "",
  consumables: "",
  consumablesType: "",
  orgId: "",
  serialNumber: "",
  duration: "",
  catCode: "",
  langList: [],
  // example values
  // "vendor": "RS",
  // "lastname": "a",
  // "product_type": "TSUB",
  // "firstname": "a",
  // "consumables_type": "",
  // "orgID": "83",
  // "validate": "true",    // note: we don't store it
  // "serial_number": "6048790014977348604",
  // "duration": "3",
  // "consumables": "0",
  // "ExistingUser": "Y",
  // "catCode": "TSUB-CS-NA-03-PE-NA-NA-N-4",
  // "lang_list": "FRA, ESC, KOR, VIE, FAR, CHI, DEU, ITA, JPN, ARA, HIN, TOC, EBR, TGL, POR, TUR, TOW, POL, NED, TOS, GRK, HEB, SVE, GLE, RUS, TOGS, ENG, ESP"
  existingUser: "",
  existingUserBoolean: false,
  // ************* PAGE TWO
  productName: "",
  firstNameError: "",
  lastNameError: "",
  needPassword: true,
  password: "",
  passwordError: "",
  confirmPassword: "",
  confirmPasswordError: "",
  // these two need to agree
  showPassword: false,
  passwordInputType: "password",
  currency: "",
  currencyError: "",
  supportLanguage: "",
  learningLanguageCode: "",
  learningLanguageOnlyOne: "",
  learningLanguageList: [],
  learningLanguageError: "",
  isInvalidLearningLanguageSelected: false,
  pageError: "",
  licenses: [],
  redirectUrl: ""
};
var productActivationReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    case PA_CONFIG:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        shortLocale: action.payload.locale.substr(0, 2),
        localeBase: translations[action.payload.locale],
        config: action.payload
      });

    case PA_IS_SUBMITTING:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isSubmitting: action.payload
      });

    case PA_ID:
      return _objectSpread2(_objectSpread2({}, state), splitId(action.payload));

    case PA_ID_PART_1:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        idPart1: ensureString(action.payload)
      });

    case PA_ID_PART_2:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        idPart2: ensureString(action.payload)
      });

    case PA_ID_PART_3:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        idPart3: ensureString(action.payload)
      });

    case PA_ID_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        idError: action.payload
      });

    case PA_CLEAR_ID_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        idError: "",
        apiError: "" // NOTE!

      });

    case PA_EMAIL_ADDRESS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        emailAddress: ensureString(action.payload).trim()
      });

    case PA_EMAIL_ADDRESS_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        emailAddressError: action.payload
      });

    case PA_CLEAR_EMAIL_ADDRESS_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        emailAddressError: "",
        apiError: "" // NOTE!

      });

    case PA_TERMS_ACCEPTED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        termsAccepted: action.payload
      });

    case PA_TERMS_ACCEPTED_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        termsAcceptedError: action.payload
      });

    case PA_CLEAR_TERMS_ACCEPTED_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        termsAcceptedError: "",
        apiError: "" // NOTE!

      });

    case PA_API_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        apiError: action.payload
      });

    case PA_CLEAR_ERRORS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        idError: "",
        emailAddressError: "",
        termsAcceptedError: "",
        apiError: "",
        firstNameError: "",
        // combining page 1 and page 2
        lastNameError: "",
        passwordError: "",
        confirmPasswordError: "",
        currencyError: "",
        learningLanguageError: ""
      }, clearPageError(state, action.payload));

    case PA_VENDOR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        vendor: ensureString(action.payload)
      });

    case PA_PRODUCT_TYPE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        productType: ensureString(action.payload)
      });

    case PA_FIRST_NAME:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        firstName: ensureString(action.payload).trim()
      });

    case PA_LAST_NAME:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        lastName: ensureString(action.payload).trim()
      });

    case PA_CONSUMABLES:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        consumables: ensureString(action.payload)
      });

    case PA_CONSUMABLES_TYPE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        consumablesType: ensureString(action.payload)
      });

    case PA_ORG_ID:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        orgId: ensureString(action.payload)
      });

    case PA_SERIAL_NUMBER:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        serialNumber: ensureString(action.payload)
      });

    case PA_DURATION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        duration: composeDuration(action.payload)
      });

    case PA_CAT_CODE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        catCode: ensureString(action.payload)
      });

    case PA_LANG_LIST:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        langList: ensureString(action.payload).split(",").map(function (l) {
          return l.trim();
        })
      });

    case PA_EXISTING_USER:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        existingUser: ensureString(action.payload),
        existingUserBoolean: ensureString(action.payload) !== "N"
      });

    case PA_EXISTING_USER_BOOLEAN:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        existingUserBoolean: action.payload
      });

    case PA_INITIALIZE_PAGE_2:
      // learning language gets reset in validate api call in page one
      // first and last name gets set/reset in validate api handling
      return _objectSpread2(_objectSpread2(_objectSpread2({}, state), {}, {
        supportLanguage: state.config.locale,
        currency: "",
        showPassword: false,
        passwordInputType: "password",
        password: "",
        confirmPassword: ""
      }, clearErrors$1(state, true)), computeLearningLanguageState$1(state.localeBase.pg2.learningLanguages, state.langList));

    case PA_LICENSES:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        licenses: action.payload ? action.payload : []
      });

    case PA_FIRST_NAME_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        firstNameError: action.payload
      });

    case PA_LAST_NAME_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        lastNameError: action.payload
      });

    case PA_PASSWORD:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        password: action.payload
      });

    case PA_PASSWORD_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        passwordError: action.payload
      });

    case PA_CONFIRM_PASSWORD:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        confirmPassword: action.payload
      });

    case PA_CONFIRM_PASSWORD_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        confirmPasswordError: action.payload
      });

    case PA_CURRENCY:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        currency: action.payload
      });

    case PA_CURRENCY_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        currencyError: action.payload
      });

    case PA_LEARNING_LANGUAGE_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        learningLanguageError: action.payload
      });

    case PA_LEARNING_LANGUAGE_CODE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        learningLanguageCode: action.payload
      });

    case PA_PAGE_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        pageError: action.payload
      });

    case PA_REDIRECT_URL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        redirectUrl: action.payload
      });

    case PA_SHOW_PASSWORD:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        showPassword: action.payload,
        passwordInputType: action.payload ? "text" : "password"
      });

    case PA_CLEAR_FIRST_NAME_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        firstNameError: ""
      }, clearPageError(state));

    case PA_CLEAR_LAST_NAME_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        lastNameError: ""
      }, clearPageError(state));

    case PA_CLEAR_PASSWORD_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        passwordError: ""
      }, clearPageError(state));

    case PA_CLEAR_CONFIRM_PASSWORD_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        confirmPasswordError: ""
      }, clearPageError(state));

    case PA_CLEAR_CURRENCY_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        currencyError: ""
      }, clearPageError(state));

    case PA_CLEAR_LEARNING_LANGUAGE_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        learningLanguageError: ""
      }, clearPageError(state));

    case PA_LEARNING_LANGUAGE_STATE:
      return _objectSpread2(_objectSpread2({}, state), computeLearningLanguageState$1(state.localeBase.pg2.learningLanguages, state.langList));

    case PA_PRODUCT_NAME:
      return _objectSpread2(_objectSpread2({}, state), computeProductName$1(state));

    case PA_CHECK_SELECTED_LEARNING_LANGUAGE:
      return _objectSpread2(_objectSpread2({}, state), checkSelectedLearningLanguage$1(state));

    case PA_SUPPORT_LANGUAGE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        supportLanguage: action.payload
      });

    default:
      return state;
  }
});

var composeDuration = function composeDuration(p) {
  p = ensureString(p);

  if (p.length <= 1) {
    p = "0" + p;
  }

  return p;
};

var splitId = function splitId(p) {
  p = ensureString(p);
  var parts = p.split("-");

  if (parts.length !== 3) {
    console.error("activation id does not have 3 parts");
    return {};
  }

  if (parts[0].length !== 5 || parts[1].length !== 5 || parts[2].length !== 5) {
    console.error("at least one part of activation id does not have 5 characters");
    return {};
  }

  return {
    idPart1: parts[0],
    idPart2: parts[1],
    idPart3: parts[2]
  };
};

var computeProductName$1 = function computeProductName(state) {
  // we don't translate product names :-)
  var productName = "";
  /* WDCMS-592 */

  var durationText = isLifetimeSubscription(state) ? "Lifetime Subscription" : state.duration + " Month";

  if (isTotaleProduct(state)) {
    // NOTE: ACK WAS INTRODUCED TO THIS CONDITION NOT IN ORIG LIFERAY CODE
    productName = "Online Subscription - " + durationText;
  } else if (isHomeschoolProduct(state)) {
    productName = "Homeschool Subscription - " + durationText;
  }

  if (isMobileOnlyProduct(state)) {
    productName = "Learn Languages with Rosetta Stone";
  }

  return {
    productName: productName
  };
};

var computeLearningLanguageState$1 = function computeLearningLanguageState(translations, langList) {
  var stateUpdate = {};
  stateUpdate.learningLanguageList = [];
  stateUpdate.learningLanguageOnlyOne = "";
  stateUpdate.learningLanguageCode = ""; // set for both select and single language

  var findTranslation = function findTranslation(langCode) {
    return translations.find(function (l) {
      return l.code.toLowerCase().trim() === langCode.toLowerCase().trim();
    });
  };

  if (langList.length === 1) {
    // there is only one language available so we hide the select and show a label instead
    var learningLanguage = findTranslation(langList[0]);
    stateUpdate.learningLanguageOnlyOne = learningLanguage.text.trim();
    stateUpdate.learningLanguageCode = learningLanguage.code.toUpperCase().trim();
  } else if (langList.length >= 1) {
    // show the dropdown
    var _iterator = _createForOfIteratorHelper(langList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var l = _step.value;

        // i don't know what these learning language are but we are ignoring them just like Liferay
        if (!/^TOC|TOS|TOW|TOLS|TOGS|TOPS$/i.test(l)) {
          var transLang = findTranslation(l);

          if (!transLang) {
            console.error("did not find ll in yaml pg2.learningLanguages", l);
          }

          var copyLang = {
            code: transLang.code.toUpperCase().trim(),
            text: transLang.text.trim()
          };
          stateUpdate.learningLanguageList.push(copyLang);
        }
      } // TODO not sure localeCompare is what we want here cause we cannot specify the locale

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    stateUpdate.learningLanguageList = stateUpdate.learningLanguageList.sort(function (a, b) {
      return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
    });
  } else {
    // FIXME does this case ever come up?
    // Liferay assigned eng as your learning language but didn't show it -- strange
    // We are going to show it.
    var _learningLanguage = findTranslation("eng");

    stateUpdate.learningLanguageOnlyOne = _learningLanguage.text.trim();
    stateUpdate.learningLanguageCode = _learningLanguage.code.toUpperCase().trim();
  }

  return stateUpdate;
};

var clearPageError = function clearPageError(state) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    // we don't clear this error until you change the language
    pageError: force || !state.isInvalidLearningLanguageSelected ? "" : state.pageError
  };
};

var clearErrors$1 = function clearErrors(state, force) {
  return _objectSpread2({
    firstNameError: "",
    lastNameError: "",
    passwordError: "",
    confirmPasswordError: "",
    currencyError: "",
    learningLanguageError: ""
  }, clearPageError(state, force));
};

var checkSelectedLearningLanguage$1 = function checkSelectedLearningLanguage(state) {
  var stateChanges = {};
  stateChanges.isInvalidLearningLanguageSelected = false;
  stateChanges = _objectSpread2(_objectSpread2({}, stateChanges), clearPageError(stateChanges, true));

  if (!state.learningLanguageCode) {
    return stateChanges;
  } // find the license


  var license = state.licenses.find(function (l) {
    return l.language.toLowerCase() === state.learningLanguageCode.toLowerCase();
  });

  if (license) {
    var blockPurchases = convertToBoolean(license.blockPurchases);
    var blockMobile = convertToBoolean(license.blockMobile);
    var isHomeschool = convertToBoolean(license.isHomeschool);
    var source = license.source;
    var subscriptionId = license.subscriptionID;
    var learningLanguageName = codeToLearningLanguageName(state);

    if (blockPurchases && source === "AMAZON") {
      var link = "https://www.amazon.com/gp/swvgdtt/your-account/subscription.html?ie=UTF8&subscriptionID=" + subscriptionId;
      var templateText = state.localeBase.pg2.amz;
      templateText = templateText.replace("AMAZON_LINK", link);
      templateText = templateText.replace("LANGUAGE_NAME", learningLanguageName);
      stateChanges.pageError = templateText;
      stateChanges.isInvalidLearningLanguageSelected = true;
    } else if (blockPurchases && source === "IOS_Apple") {
      var _templateText = state.localeBase.pg2.apple;
      _templateText = _templateText.replace("LANGUAGE_NAME", learningLanguageName);
      stateChanges.pageError = _templateText;
      stateChanges.isInvalidLearningLanguageSelected = true;
    } else if (blockPurchases && source === "googlePlay") {
      var _templateText2 = state.localeBase.pg2.google;
      _templateText2 = _templateText2.replace("LANGUAGE_NAME", learningLanguageName);
      stateChanges.pageError = _templateText2;
      stateChanges.isInvalidLearningLanguageSelected = true;
    } else {
      if (isMobileOnlyProduct(state)) {
        if (blockMobile) {
          stateChanges.isInvalidLearningLanguageSelected = true;

          if (isHomeschool) {
            stateChanges.pageError = state.localeBase.pg2.tsub;
          } else {
            stateChanges.pageError = state.localeBase.pg2.mo;
          }
        }
      } else if (isHomeschoolProduct(state)) {
        if (!isHomeschool) {
          stateChanges.pageError = state.localeBase.pg2.hs;
          stateChanges.isInvalidLearningLanguageSelected = true;
        }
      } else if (isTotaleProduct(state)) {
        if (isHomeschool) {
          stateChanges.pageError = state.localeBase.pg2.tsub;
          stateChanges.isInvalidLearningLanguageSelected = true;
        }
      }
    }
  }

  return stateChanges;
};

var codeToLearningLanguageName = function codeToLearningLanguageName(state) {
  var translations = state.localeBase.pg2.learningLanguages;

  var findTranslation = function findTranslation(langCode) {
    return translations.find(function (l) {
      return l.code.toLowerCase().trim() === langCode.toLowerCase().trim();
    });
  };

  var translation = findTranslation(state.learningLanguageCode);
  return translation ? translation.text : "";
};
var isLanguageCodeUnlimited = function isLanguageCodeUnlimited(state) {
  return state.learningLanguageCode === "ALL";
};
var isLifetimeSubscription = function isLifetimeSubscription(state) {
  return state.catCode.split("-")[3] === "LT";
};
var isMobileOnlyProduct = function isMobileOnlyProduct(state) {
  return state.catCode.split("-")[4] === "MO";
};
/*
These days we only support:
  HACK/HSUB/TSUB/ACK

  HACK and HSUB (homeschool) are the same product as well as TSUB and ACK (totale)
  HACK and ACK are given to retailers is the difference.  ACK stands for
  "activation card key"

NO LONGER SUPPORTED:
  KRS - Kids RS
  FBS - Fit Brains
  TMSUB - Tell Me More

ACK-CS-NA-12-PE-RS-US-Y-4
TSUB-ALL-NA-LT-PE-NA-NA-N-4
HACK-ALL-NA-12-HS-NA-NA-Y-4

  The second to last boolean groups stands for "tangible", e.g., a physical
  card vs and online product.

  "CS" stands for "customer select"
  "PE" stands for "personal edition", "HS" homeschool edition
*/

var isHomeschoolProduct = function isHomeschoolProduct(state) {
  var firstPart = state.catCode.split("-")[0];
  return firstPart === "HSUB" || firstPart === "HACK";
};

var isTotaleProduct = function isTotaleProduct(state) {
  var firstPart = state.catCode.split("-")[0];
  return firstPart === "TSUB" || isTotaleRetailProduct(state);
};
var isActivelySoldProduct = function isActivelySoldProduct(state) {
  return isHomeschoolProduct(state) || isTotaleProduct(state);
};
var isTotaleRetailProduct = function isTotaleRetailProduct(state) {
  var firstPart = state.catCode.split("-")[0];
  return firstPart === "ACK";
};

var SET_FREE_TRIAL_FORM_SUBMISSION = "SET_FREE_TRIAL_FORM_SUBMISSION";
var SET_FREE_TRIAL_IS_LOADING = "SET_FREE_TRIAL_IS_LOADING";
var SET_FREE_TRIAL_SUBMISSION_RESPONSE = "SET_FREE_TRIAL_SUBMISSION_RESPONSE";
var SET_FREE_TRIAL_SUBMISSION_STATUS = "SET_FREE_TRIAL_SUBMISSION_STATUS";
var SET_FREE_TRIAL_SUBMISSION_ERROR = "SET_FREE_TRIAL_SUBMISSION_ERROR";
var CLEAR_FREE_TRIAL_SUBMISSION_ERROR = "CLEAR_FREE_TRIAL_SUBMISSION_ERROR";

var submissionStatus = {
  open: "open",
  sent: "sent",
  received: "received",
  error: "error",
  success: "success",
  complete: "complete"
};
var storeRoot$3 = "freeTrial";

var freeTrialFormConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  submissionStatus: submissionStatus,
  storeRoot: storeRoot$3
});

var initialFormData$2 = {
  submission: {},
  isLoading: false,
  response: null,
  errors: null,
  status: submissionStatus.open
};

var freeTrialFormReducers = function freeTrialFormReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFormData$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_FREE_TRIAL_FORM_SUBMISSION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        submission: action.payload
      });

    case SET_FREE_TRIAL_IS_LOADING:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: action.payload
      });

    case SET_FREE_TRIAL_SUBMISSION_RESPONSE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        response: action.payload
      });

    case SET_FREE_TRIAL_SUBMISSION_STATUS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.payload
      });

    case SET_FREE_TRIAL_SUBMISSION_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        error: action.payload
      });

    case CLEAR_FREE_TRIAL_SUBMISSION_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        error: null
      });

    default:
      return state;
  }
};

var actionTypes$1 = {
  OVERLAY_SET_ACTIVE: "OVERLAY_SET_ACTIVE",
  OVERLAY_CLEAR: "OVERLAY_CLEAR"
};

var initialFormData$1 = {
  active: null
};

var emailCollectionFormReducers = function emailCollectionFormReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFormData$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes$1.OVERLAY_CLEAR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        active: null
      });

    case actionTypes$1.OVERLAY_SET_ACTIVE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        active: action.payload
      });

    default:
      return state;
  }
};

var storeRoot$2 = "overlay";

var actionTypes = {
  SET_CART_IFRAME_URL: "SET_CART_IFRAME_URL",
  SET_SHOW_LOADING_MESSAGES: "SET_SHOW_LOADING_MESSAGES",
  SET_IS_CART_VISIBLE: "SET_IS_CART_VISIBLE",
  SET_IS_OVERLAY_VISIBLE: "SET_IS_OVERLAY_VISIBLE"
};

var initialCartData = {
  cartIframeUrl: "",
  showLoadingMessages: true,
  isCartVisible: false,
  isOverlayVisible: true
};

var cartReducers = function cartReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCartData;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes.SET_CART_IFRAME_URL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        cartIframeUrl: action.payload
      });

    case actionTypes.SET_SHOW_LOADING_MESSAGES:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        showLoadingMessages: action.payload
      });

    case actionTypes.SET_IS_CART_VISIBLE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isCartVisible: action.payload
      });

    case actionTypes.SET_IS_OVERLAY_VISIBLE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isOverlayVisible: action.payload
      });

    default:
      return state;
  }
};

var storeRoot$1 = "cart";

var cartConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeRoot: storeRoot$1
});

var SET_GLOBAL_LANGUAGE_ID = "SET_GLOBAL_LANGUAGE_ID";

var initialFormData = {
  languageId: "esp"
};

var globalReducers = function globalReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFormData;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_GLOBAL_LANGUAGE_ID:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        languageId: action.payload
      });

    default:
      return state;
  }
};

var storeRoot = "global";

var globalConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeRoot: storeRoot
});

var _combineReducers;
var rootReducer = combineReducers((_combineReducers = {}, _defineProperty(_combineReducers, storeRoot$6, emailCollectionFormReducers$1), _defineProperty(_combineReducers, storeRoot$5, leadGenerationReducer), _defineProperty(_combineReducers, storeRoot$2, emailCollectionFormReducers), _defineProperty(_combineReducers, storeRoot$1, cartReducers), _defineProperty(_combineReducers, storeRoot$4, productActivationReducer), _defineProperty(_combineReducers, storeRoot$3, freeTrialFormReducers), _defineProperty(_combineReducers, storeRoot, globalReducers), _combineReducers));

var setEmailCollectionSubmission = function setEmailCollectionSubmission(submission) {
  return {
    type: actionTypes$2.EMAIL_COLLECTION_SUBMISSION,
    payload: submission
  };
};
var setEmailCollectionResponse = function setEmailCollectionResponse(response) {
  return {
    type: actionTypes$2.EMAIL_COLLECTION_RESPONSE,
    payload: response
  };
};
var setEmailCollectionStatus = function setEmailCollectionStatus(status) {
  return {
    type: actionTypes$2.EMAIL_COLLECTION_STATUS,
    payload: status
  };
};

var emailCollectionActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setEmailCollectionSubmission: setEmailCollectionSubmission,
  setEmailCollectionResponse: setEmailCollectionResponse,
  setEmailCollectionStatus: setEmailCollectionStatus
});

var getSubmissionStatus$1 = function getSubmissionStatus(state) {
  return state[storeRoot$6].status;
};
var getSubmissionData$1 = function getSubmissionData(state) {
  return state[storeRoot$6].submission;
};
var getResponseData$1 = function getResponseData(state) {
  return state[storeRoot$6].response;
};

var emailCollectionSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSubmissionStatus: getSubmissionStatus$1,
  getSubmissionData: getSubmissionData$1,
  getResponseData: getResponseData$1
});

var fetchEmailCollection = function fetchEmailCollection(_ref) {
  var cid = _ref.cid,
      consentType = _ref.consentType,
      demo_type = _ref.demo_type,
      email = _ref.email,
      language = _ref.language,
      newsletter_type = _ref.newsletter_type,
      visitCountryCode = _ref.visitCountryCode,
      web_path = _ref.web_path,
      website = _ref.website;
  var data = {
    cid: cid,
    consentType: consentType,
    demoType: demo_type,
    emailAddress: email,
    emailNotify: 0,
    formUrl: web_path,
    newsletterType: newsletter_type,
    siteLang: language || "ENG",
    verifyEmail: true,
    visitCountryCode: visitCountryCode,
    website: website
  };

  if (data.consentType === "implicit") {
    data.emailNotify = 1;
  } // Endpoint API value is set in the env files at the root of the hub.


  return fetch(process.env.RS_API_WEBLEADS, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(data)
  }).then(function (response) {
    return response.text();
  }).then(function (responseJson) {
    return responseJson;
  });
};

var _marked$6 = /*#__PURE__*/regeneratorRuntime.mark(sendEmailCollectionData),
    _marked2$5 = /*#__PURE__*/regeneratorRuntime.mark(sagas$3);

function sendEmailCollectionData() {
  var data, processedData;
  return regeneratorRuntime.wrap(function sendEmailCollectionData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getSubmissionData$1);

        case 2:
          data = _context.sent;
          _context.next = 5;
          return put(setEmailCollectionStatus(submissionStatus$2.sent));

        case 5:
          _context.next = 7;
          return call(fetchEmailCollection, data);

        case 7:
          processedData = _context.sent;
          _context.next = 10;
          return put(setEmailCollectionResponse(JSON.parse(processedData)));

        case 10:
          _context.next = 12;
          return put(setEmailCollectionStatus(submissionStatus$2.received));

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$6);
}

function sagas$3() {
  return regeneratorRuntime.wrap(function sagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(actionTypes$2.EMAIL_COLLECTION_SUBMISSION, sendEmailCollectionData);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$5);
}

var setLeadGenerationSubmission = function setLeadGenerationSubmission(submission) {
  return {
    type: LEAD_GENERATION_SUBMISSION,
    payload: submission
  };
};
var setLeadGenerationResponse = function setLeadGenerationResponse(response) {
  return {
    type: LEAD_GENERATION_RESPONSE,
    payload: response
  };
};
var setLeadGenerationStatus = function setLeadGenerationStatus(status) {
  return {
    type: LEAD_GENERATION_STATUS,
    payload: status
  };
};
var setLeadGenerationScheduleAppointment = function setLeadGenerationScheduleAppointment(schedule) {
  return {
    type: LEAD_GENERATION_SET_SCHEDULE,
    payload: schedule
  };
};
var setLeadGenerationAppointment = function setLeadGenerationAppointment(appointment) {
  return {
    type: LEAD_GENERATION_SET_APPOINTMENT,
    payload: appointment
  };
};
var setLeadGenerationCompletionRedirect = function setLeadGenerationCompletionRedirect(destination) {
  return {
    type: LEAD_GENERATION_SET_COMPLETION_REDIRECT,
    payload: destination
  };
};
var setLeadGenerationClearForm = function setLeadGenerationClearForm() {
  return {
    type: LEAD_GENERATION_CLEAR
  };
};

var leadGenerationActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setLeadGenerationSubmission: setLeadGenerationSubmission,
  setLeadGenerationResponse: setLeadGenerationResponse,
  setLeadGenerationStatus: setLeadGenerationStatus,
  setLeadGenerationScheduleAppointment: setLeadGenerationScheduleAppointment,
  setLeadGenerationAppointment: setLeadGenerationAppointment,
  setLeadGenerationCompletionRedirect: setLeadGenerationCompletionRedirect,
  setLeadGenerationClearForm: setLeadGenerationClearForm
});

var getScheduleAppointment = function getScheduleAppointment(state) {
  return state[storeRoot$5].schedule_appointment;
};
var getCompletionRedirect = function getCompletionRedirect(state) {
  return state[storeRoot$5].completion_redirect;
};
var getSubmissionStatus = function getSubmissionStatus(state) {
  return state[storeRoot$5].status;
};
var getSubmissionData = function getSubmissionData(state) {
  return state[storeRoot$5].submission;
};
var getResponseData = function getResponseData(state) {
  return state[storeRoot$5].response;
};
var getAllData = function getAllData(state) {
  return state[storeRoot$5];
};

var leadGenerationSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getScheduleAppointment: getScheduleAppointment,
  getCompletionRedirect: getCompletionRedirect,
  getSubmissionStatus: getSubmissionStatus,
  getSubmissionData: getSubmissionData,
  getResponseData: getResponseData,
  getAllData: getAllData
});

var sendLeadGenerationData$1 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Data Cleanup
            // This refers to react state, not geolocation state.
            // geolocation state can be found at state_code
            delete payload.state;
            delete payload.key; // Endpoint API value is set in the env files at the root of the hub.

            return _context.abrupt("return", fetch(process.env.RS_API_LEAD_GENERATION, {
              method: "POST",
              mode: "cors",
              cache: "no-cache",
              credentials: "omit",
              headers: {
                "Content-Type": "application/json"
              },
              redirect: "follow",
              referrerPolicy: "no-referrer",
              body: JSON.stringify(payload)
            }).then(function (response) {
              return response.text();
            }).then(function (responseJson) {
              return responseJson;
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendLeadGenerationData(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fireGTMCustomEvents = function fireGTMCustomEvents(payload) {
  if (typeof window !== "undefined") {
    // Define dataLayer if it does not exist already
    window.dataLayer = window.dataLayer || []; // Fire "b2bRequest" on all instances (Used by EMEA GTM container)

    window.dataLayer.push({
      event: "b2bRequest"
    }); // Fire "b2bRequest:soi" only when visitor opts in to marketing (Used by EMEA GTM container)

    if (payload && payload.explicitOptIn && payload.explicitOptIn === true) {
      window.dataLayer.push({
        event: "b2bRequest:soi"
      });
    } // Fire either Enterprise or Education conversion custom GTM event


    if (payload && payload.vertical && /^enterprise/i.test(payload.vertical)) {
      window.dataLayer.push({
        event: "enterpriseLeadSuccess",
        eneLeadFormData: payload
      });
    } else if (payload && payload.vertical && /^education/i.test(payload.vertical)) {
      window.dataLayer.push({
        event: "educationLeadSuccess",
        eneLeadFormData: payload
      });
    }
  }
};

var _marked$5 = /*#__PURE__*/regeneratorRuntime.mark(sendLeadGenerationData),
    _marked2$4 = /*#__PURE__*/regeneratorRuntime.mark(sagas$2);

function sendLeadGenerationData() {
  var formData, processedData;
  return regeneratorRuntime.wrap(function sendLeadGenerationData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getSubmissionData);

        case 2:
          formData = _context.sent;
          _context.next = 5;
          return put(setLeadGenerationStatus(submissionStatus$1.sent));

        case 5:
          _context.next = 7;
          return call(sendLeadGenerationData$1, formData);

        case 7:
          processedData = _context.sent;
          _context.next = 10;
          return put(setLeadGenerationResponse(processedData));

        case 10:
          _context.next = 12;
          return put(setLeadGenerationStatus(submissionStatus$1.received));

        case 12:
          _context.next = 14;
          return put(setLeadGenerationStatus(submissionStatus$1.success));

        case 14:
          _context.next = 16;
          return call(fireGTMCustomEvents, formData);

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$5);
}

function sagas$2() {
  return regeneratorRuntime.wrap(function sagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(LEAD_GENERATION_SUBMISSION, sendLeadGenerationData);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$4);
}

var verifyId$1 = function verifyId(navigate) {
  return {
    type: PA_VERIFY_ID,
    payload: {
      navigate: navigate
    }
  };
}; // Will only have payload when step-2
// has url params. ie, user was sent to step-2
// after completing step-1 in narwhal

var check$1 = function check(runVerifyId, navigate) {
  return {
    type: PA_CHECK,
    payload: {
      runVerifyId: runVerifyId,
      navigate: navigate
    }
  };
};
var claim$1 = function claim(navigate, location) {
  return {
    type: PA_CLAIM,
    payload: {
      navigate: navigate,
      location: location
    }
  };
};
var setConfig = function setConfig(p) {
  return {
    type: PA_CONFIG,
    payload: p
  };
};
var setIsSubmitting = function setIsSubmitting(p) {
  return {
    type: PA_IS_SUBMITTING,
    payload: p
  };
};
var setId = function setId(p) {
  return {
    type: PA_ID,
    payload: p
  };
};
var setIdPart1 = function setIdPart1(p) {
  return {
    type: PA_ID_PART_1,
    payload: p
  };
};
var setIdPart2 = function setIdPart2(p) {
  return {
    type: PA_ID_PART_2,
    payload: p
  };
};
var setIdPart3 = function setIdPart3(p) {
  return {
    type: PA_ID_PART_3,
    payload: p
  };
};
var clearIdError = function clearIdError() {
  return {
    type: PA_CLEAR_ID_ERROR
  };
};
var setIdError = function setIdError(p) {
  return {
    type: PA_ID_ERROR,
    payload: p
  };
};
var setEmailAddress = function setEmailAddress(p) {
  return {
    type: PA_EMAIL_ADDRESS,
    payload: p
  };
};
var setEmailAddressError = function setEmailAddressError(p) {
  return {
    type: PA_EMAIL_ADDRESS_ERROR,
    payload: p
  };
};
var clearEmailAddressError = function clearEmailAddressError() {
  return {
    type: PA_CLEAR_EMAIL_ADDRESS_ERROR
  };
}; // boolean

var setTermsAccepted = function setTermsAccepted(p) {
  return {
    type: PA_TERMS_ACCEPTED,
    payload: p
  };
};
var setTermsAcceptedError = function setTermsAcceptedError(p) {
  return {
    type: PA_TERMS_ACCEPTED_ERROR,
    payload: p
  };
};
var clearTermsAcceptedError = function clearTermsAcceptedError() {
  return {
    type: PA_CLEAR_TERMS_ACCEPTED_ERROR
  };
};
var clearErrors = function clearErrors() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: PA_CLEAR_ERRORS,
    payload: force
  };
};
var setApiError = function setApiError(p) {
  return {
    type: PA_API_ERROR,
    payload: p
  };
};
var setVendor = function setVendor(p) {
  return {
    type: PA_VENDOR,
    payload: p
  };
};
var setProductType = function setProductType(p) {
  return {
    type: PA_PRODUCT_TYPE,
    payload: p
  };
};
var setFirstName = function setFirstName(p) {
  return {
    type: PA_FIRST_NAME,
    payload: p
  };
};
var setLastName = function setLastName(p) {
  return {
    type: PA_LAST_NAME,
    payload: p
  };
};
var setConsumables = function setConsumables(p) {
  return {
    type: PA_CONSUMABLES,
    payload: p
  };
};
var setConsumablesType = function setConsumablesType(p) {
  return {
    type: PA_CONSUMABLES_TYPE,
    payload: p
  };
};
var setOrgId = function setOrgId(p) {
  return {
    type: PA_ORG_ID,
    payload: p
  };
};
var setSerialNumber = function setSerialNumber(p) {
  return {
    type: PA_SERIAL_NUMBER,
    payload: p
  };
};
var setDuration = function setDuration(p) {
  return {
    type: PA_DURATION,
    payload: p
  };
};
var setCatCode = function setCatCode(p) {
  return {
    type: PA_CAT_CODE,
    payload: p
  };
};
var setLangList = function setLangList(p) {
  return {
    type: PA_LANG_LIST,
    payload: p
  };
};
var setExistingUser = function setExistingUser(p) {
  return {
    type: PA_EXISTING_USER,
    payload: p
  };
};
var setExistingUserBoolean = function setExistingUserBoolean(p) {
  return {
    type: PA_EXISTING_USER_BOOLEAN,
    payload: p
  };
}; // ********* PAGE TWO

var setSupportLanguage = function setSupportLanguage(v) {
  return {
    type: PA_SUPPORT_LANGUAGE,
    payload: v
  };
};
var setRedirectUrl = function setRedirectUrl(v) {
  return {
    type: PA_REDIRECT_URL,
    payload: v
  };
};
var checkSelectedLearningLanguage = function checkSelectedLearningLanguage() {
  return {
    type: PA_CHECK_SELECTED_LEARNING_LANGUAGE
  };
};
var initializePage2 = function initializePage2() {
  return {
    type: PA_INITIALIZE_PAGE_2
  };
};
var setLicenses = function setLicenses(v) {
  return {
    type: PA_LICENSES,
    payload: v
  };
};
var setFirstNameError = function setFirstNameError(v) {
  return {
    type: PA_FIRST_NAME_ERROR,
    payload: v
  };
};
var setLastNameError = function setLastNameError(v) {
  return {
    type: PA_LAST_NAME_ERROR,
    payload: v
  };
};
var setPassword = function setPassword(v) {
  return {
    type: PA_PASSWORD,
    payload: v
  };
};
var setShowPassword = function setShowPassword(v) {
  return {
    type: PA_SHOW_PASSWORD,
    payload: v
  };
};
var setPasswordError = function setPasswordError(v) {
  return {
    type: PA_PASSWORD_ERROR,
    payload: v
  };
};
var setConfirmPassword = function setConfirmPassword(v) {
  return {
    type: PA_CONFIRM_PASSWORD,
    payload: v
  };
};
var setConfirmPasswordError = function setConfirmPasswordError(v) {
  return {
    type: PA_CONFIRM_PASSWORD_ERROR,
    payload: v
  };
};
var setCurrency = function setCurrency(v) {
  return {
    type: PA_CURRENCY,
    payload: v
  };
};
var setCurrencyError = function setCurrencyError(v) {
  return {
    type: PA_CURRENCY_ERROR,
    payload: v
  };
};
var setLearningLanguageCode = function setLearningLanguageCode(v) {
  return {
    type: PA_LEARNING_LANGUAGE_CODE,
    payload: v
  };
};
var setLearningLanguageError = function setLearningLanguageError(v) {
  return {
    type: PA_LEARNING_LANGUAGE_ERROR,
    payload: v
  };
};
var setPageError = function setPageError(v) {
  return {
    type: PA_PAGE_ERROR,
    payload: v
  };
};
var clearFirstNameError = function clearFirstNameError() {
  return {
    type: PA_CLEAR_FIRST_NAME_ERROR
  };
};
var clearLastNameError = function clearLastNameError() {
  return {
    type: PA_CLEAR_LAST_NAME_ERROR
  };
};
var clearPasswordError = function clearPasswordError() {
  return {
    type: PA_CLEAR_PASSWORD_ERROR
  };
};
var clearConfirmPasswordError = function clearConfirmPasswordError() {
  return {
    type: PA_CLEAR_CONFIRM_PASSWORD_ERROR
  };
};
var clearCurrencyError = function clearCurrencyError() {
  return {
    type: PA_CLEAR_CURRENCY_ERROR
  };
};
var clearLearningLanguageError = function clearLearningLanguageError() {
  return {
    type: PA_CLEAR_LEARNING_LANGUAGE_ERROR
  };
};
var computeLearningLanguageState = function computeLearningLanguageState() {
  return {
    type: PA_LEARNING_LANGUAGE_STATE
  };
};
var computeProductName = function computeProductName() {
  return {
    type: PA_PRODUCT_NAME
  };
};

var productActivationActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  verifyId: verifyId$1,
  check: check$1,
  claim: claim$1,
  setConfig: setConfig,
  setIsSubmitting: setIsSubmitting,
  setId: setId,
  setIdPart1: setIdPart1,
  setIdPart2: setIdPart2,
  setIdPart3: setIdPart3,
  clearIdError: clearIdError,
  setIdError: setIdError,
  setEmailAddress: setEmailAddress,
  setEmailAddressError: setEmailAddressError,
  clearEmailAddressError: clearEmailAddressError,
  setTermsAccepted: setTermsAccepted,
  setTermsAcceptedError: setTermsAcceptedError,
  clearTermsAcceptedError: clearTermsAcceptedError,
  clearErrors: clearErrors,
  setApiError: setApiError,
  setVendor: setVendor,
  setProductType: setProductType,
  setFirstName: setFirstName,
  setLastName: setLastName,
  setConsumables: setConsumables,
  setConsumablesType: setConsumablesType,
  setOrgId: setOrgId,
  setSerialNumber: setSerialNumber,
  setDuration: setDuration,
  setCatCode: setCatCode,
  setLangList: setLangList,
  setExistingUser: setExistingUser,
  setExistingUserBoolean: setExistingUserBoolean,
  setSupportLanguage: setSupportLanguage,
  setRedirectUrl: setRedirectUrl,
  checkSelectedLearningLanguage: checkSelectedLearningLanguage,
  initializePage2: initializePage2,
  setLicenses: setLicenses,
  setFirstNameError: setFirstNameError,
  setLastNameError: setLastNameError,
  setPassword: setPassword,
  setShowPassword: setShowPassword,
  setPasswordError: setPasswordError,
  setConfirmPassword: setConfirmPassword,
  setConfirmPasswordError: setConfirmPasswordError,
  setCurrency: setCurrency,
  setCurrencyError: setCurrencyError,
  setLearningLanguageCode: setLearningLanguageCode,
  setLearningLanguageError: setLearningLanguageError,
  setPageError: setPageError,
  clearFirstNameError: clearFirstNameError,
  clearLastNameError: clearLastNameError,
  clearPasswordError: clearPasswordError,
  clearConfirmPasswordError: clearConfirmPasswordError,
  clearCurrencyError: clearCurrencyError,
  clearLearningLanguageError: clearLearningLanguageError,
  computeLearningLanguageState: computeLearningLanguageState,
  computeProductName: computeProductName
});

// regardless of what section of the Redux root state was actually updated."
// https://redux.js.org/usage/deriving-data-selectors
// based on that i assume that selectors can be used for reactive state
// e.g., ui state that always reflects the state of redux state

var getLocaleBase = function getLocaleBase(state) {
  return state[storeRoot$4].localeBase;
};
var getConfig = function getConfig(state) {
  return state[storeRoot$4].config;
};
var getIsSubmitting = function getIsSubmitting(state) {
  return state[storeRoot$4].isSubmitting;
};
var getIdPart1 = function getIdPart1(state) {
  return state[storeRoot$4].idPart1;
};
var getIdPart2 = function getIdPart2(state) {
  return state[storeRoot$4].idPart2;
};
var getIdPart3 = function getIdPart3(state) {
  return state[storeRoot$4].idPart3;
};
var getIdFull = function getIdFull(state) {
  return state[storeRoot$4].idPart1 + "-" + state[storeRoot$4].idPart2 + "-" + state[storeRoot$4].idPart3;
};
var getIdError = function getIdError(state) {
  return state[storeRoot$4].idError;
};
var getEmailAddress = function getEmailAddress(state) {
  return state[storeRoot$4].emailAddress;
};
var getEmailAddressError = function getEmailAddressError(state) {
  return state[storeRoot$4].emailAddressError;
};
var getTermsAccepted = function getTermsAccepted(state) {
  return state[storeRoot$4].termsAccepted;
};
var getTermsAcceptedError = function getTermsAcceptedError(state) {
  return state[storeRoot$4].termsAcceptedError;
};
var getApiError = function getApiError(state) {
  return state[storeRoot$4].apiError;
};
var getVendor = function getVendor(state) {
  return state[storeRoot$4].vendor;
};
var getProductType = function getProductType(state) {
  return state[storeRoot$4].productType;
}; // ******** page 2

var getProductName = function getProductName(state) {
  return state[storeRoot$4].productName;
};
var getFirstName = function getFirstName(state) {
  return state[storeRoot$4].firstName;
};
var getFirstNameError = function getFirstNameError(state) {
  return state[storeRoot$4].firstNameError;
};
var getLastName = function getLastName(state) {
  return state[storeRoot$4].lastName;
};
var getLastNameError = function getLastNameError(state) {
  return state[storeRoot$4].lastNameError;
};
var getPassword = function getPassword(state) {
  return state[storeRoot$4].password;
};
var getPasswordError = function getPasswordError(state) {
  return state[storeRoot$4].passwordError;
};
var getConfirmPassword = function getConfirmPassword(state) {
  return state[storeRoot$4].confirmPassword;
};
var getConfirmPasswordError = function getConfirmPasswordError(state) {
  return state[storeRoot$4].confirmPasswordError;
};
var getPasswordInputType = function getPasswordInputType(state) {
  return state[storeRoot$4].passwordInputType;
};
var getShowPassword = function getShowPassword(state) {
  return state[storeRoot$4].showPassword;
};
var getConsumables = function getConsumables(state) {
  return state[storeRoot$4].consumables;
};
var getConsumablesType = function getConsumablesType(state) {
  return state[storeRoot$4].consumablesType;
};
var getOrgId = function getOrgId(state) {
  return state[storeRoot$4].orgId;
};
var getSerialNumber = function getSerialNumber(state) {
  return state[storeRoot$4].serialNumber;
};
var getDuration = function getDuration(state) {
  return state[storeRoot$4].duration;
};
var getCatCode = function getCatCode(state) {
  return state[storeRoot$4].catCode;
};
var getLangList = function getLangList(state) {
  return state[storeRoot$4].langList;
};
var getExistingUser = function getExistingUser(state) {
  return state[storeRoot$4].existingUser;
};
var getExistingUserBoolean = function getExistingUserBoolean(state) {
  return state[storeRoot$4].existingUserBoolean;
};
var getUserType = function getUserType(state) {
  return state[storeRoot$4].existingUserBoolean ? "Old" : "New";
};
var getCurrency = function getCurrency(state) {
  return state[storeRoot$4].currency;
};
var getCurrencyError = function getCurrencyError(state) {
  return state[storeRoot$4].currencyError;
};
var getSupportLanguage = function getSupportLanguage(state) {
  return state[storeRoot$4].supportLanguage;
};
var getSiteId = function getSiteId(state) {
  return "rst" + state[storeRoot$4].supportLanguage.substr(3, 2);
};
var getPageError = function getPageError(state) {
  return state[storeRoot$4].pageError;
};
var getIsActivelySoldProduct = function getIsActivelySoldProduct(state) {
  return isActivelySoldProduct(state[storeRoot$4]);
};
var getIsInvalidLearningLanguageSelected = function getIsInvalidLearningLanguageSelected(state) {
  return state[storeRoot$4].isInvalidLearningLanguageSelected;
};
var getLearningLanguageOnlyOne = function getLearningLanguageOnlyOne(state) {
  return state[storeRoot$4].learningLanguageOnlyOne;
};
var getLearningLanguageError = function getLearningLanguageError(state) {
  return state[storeRoot$4].learningLanguageError;
};
var getLearningLanguageCode = function getLearningLanguageCode(state) {
  return state[storeRoot$4].learningLanguageCode;
};
var getLearningLanguageList = function getLearningLanguageList(state) {
  return state[storeRoot$4].learningLanguageList;
};
var getLocaleForClaim = function getLocaleForClaim(state) {
  return state[storeRoot$4].supportLanguage.substr(0, 2) + "_" + state[storeRoot$4].supportLanguage.substr(3, 2);
};
var getCurrencyCode = function getCurrencyCode(state) {
  return state[storeRoot$4].currency ? currencyMap[state[storeRoot$4].currency].currency : "";
}; // TODO changed from page 2 getOrgId since that name was used in page 1

var getCurrencyOrgId = function getCurrencyOrgId(state) {
  return state[storeRoot$4].currency ? currencyMap[state[storeRoot$4].currency].orgId : "";
};
var getExternalRefId = function getExternalRefId(state) {
  var duration = state[storeRoot$4].duration;
  var catCode = state[storeRoot$4].catCode; // languageCode is a three letter code that would come from the learning language select

  var languageCode = state[storeRoot$4].learningLanguageCode; // the below code was copied from Liferay and cleaned up a bit

  if (isMobileOnlyProduct(state[storeRoot$4])) {
    return catCode.replace("CS", languageCode); // not sure what this is about
  }

  var splitCatCode = catCode.split("-");

  if (isTotaleRetailProduct(state[storeRoot$4])) {
    splitCatCode[0] = "TSUB";
  }
  /* WDCMS - 592 */


  if (isLifetimeSubscription(state[storeRoot$4])) {
    duration = "LT";
  }
  /* -- WDCMS - 592 -- */


  splitCatCode[1] = languageCode;
  splitCatCode[3] = duration;
  return splitCatCode.join("-");
}; // ******** page 3

var getSuccessMarkup = function getSuccessMarkup(state) {
  return getLocaleBase(state).pg3.enjoyPre + "<b>" + (isLanguageCodeUnlimited(state[storeRoot$4]) ? getLocaleBase(state).pg3.allLanguages : codeToLearningLanguageName(state[storeRoot$4])) + "</b>" + getLocaleBase(state).pg3.enjoyPost;
};
var getRedirectUrl = function getRedirectUrl(state) {
  return state[storeRoot$4].redirectUrl;
};

var productActivationSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getLocaleBase: getLocaleBase,
  getConfig: getConfig,
  getIsSubmitting: getIsSubmitting,
  getIdPart1: getIdPart1,
  getIdPart2: getIdPart2,
  getIdPart3: getIdPart3,
  getIdFull: getIdFull,
  getIdError: getIdError,
  getEmailAddress: getEmailAddress,
  getEmailAddressError: getEmailAddressError,
  getTermsAccepted: getTermsAccepted,
  getTermsAcceptedError: getTermsAcceptedError,
  getApiError: getApiError,
  getVendor: getVendor,
  getProductType: getProductType,
  getProductName: getProductName,
  getFirstName: getFirstName,
  getFirstNameError: getFirstNameError,
  getLastName: getLastName,
  getLastNameError: getLastNameError,
  getPassword: getPassword,
  getPasswordError: getPasswordError,
  getConfirmPassword: getConfirmPassword,
  getConfirmPasswordError: getConfirmPasswordError,
  getPasswordInputType: getPasswordInputType,
  getShowPassword: getShowPassword,
  getConsumables: getConsumables,
  getConsumablesType: getConsumablesType,
  getOrgId: getOrgId,
  getSerialNumber: getSerialNumber,
  getDuration: getDuration,
  getCatCode: getCatCode,
  getLangList: getLangList,
  getExistingUser: getExistingUser,
  getExistingUserBoolean: getExistingUserBoolean,
  getUserType: getUserType,
  getCurrency: getCurrency,
  getCurrencyError: getCurrencyError,
  getSupportLanguage: getSupportLanguage,
  getSiteId: getSiteId,
  getPageError: getPageError,
  getIsActivelySoldProduct: getIsActivelySoldProduct,
  getIsInvalidLearningLanguageSelected: getIsInvalidLearningLanguageSelected,
  getLearningLanguageOnlyOne: getLearningLanguageOnlyOne,
  getLearningLanguageError: getLearningLanguageError,
  getLearningLanguageCode: getLearningLanguageCode,
  getLearningLanguageList: getLearningLanguageList,
  getLocaleForClaim: getLocaleForClaim,
  getCurrencyCode: getCurrencyCode,
  getCurrencyOrgId: getCurrencyOrgId,
  getExternalRefId: getExternalRefId,
  getSuccessMarkup: getSuccessMarkup,
  getRedirectUrl: getRedirectUrl
});

var _marked$4 = /*#__PURE__*/regeneratorRuntime.mark(validateUserInput),
    _marked2$3 = /*#__PURE__*/regeneratorRuntime.mark(handleVerifyResponse);
/**
 * Validates an email using regex
 *
 * @param {String} email An email to validate
 */

function validateEmail(email) {
  // eslint-disable-next-line
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
}

function validateUserInput() {
  var errored;
  return regeneratorRuntime.wrap(function validateUserInput$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          errored = false;
          _context.next = 3;
          return put(clearErrors());

        case 3:
          _context.next = 5;
          return select(getIdPart1);

        case 5:
          _context.t1 = !_context.sent;

          if (_context.t1) {
            _context.next = 10;
            break;
          }

          _context.next = 9;
          return select(getIdPart2);

        case 9:
          _context.t1 = !_context.sent;

        case 10:
          _context.t0 = _context.t1;

          if (_context.t0) {
            _context.next = 15;
            break;
          }

          _context.next = 14;
          return select(getIdPart3);

        case 14:
          _context.t0 = !_context.sent;

        case 15:
          if (!_context.t0) {
            _context.next = 25;
            break;
          }

          _context.t2 = put;
          _context.t3 = productActivationActions;
          _context.next = 20;
          return select(getLocaleBase);

        case 20:
          _context.t4 = _context.sent.pg1.claimEmptyErr;
          _context.t5 = _context.t3.setIdError.call(_context.t3, _context.t4);
          _context.next = 24;
          return (0, _context.t2)(_context.t5);

        case 24:
          errored = true;

        case 25:
          _context.t6 = validateEmail;
          _context.next = 28;
          return select(getEmailAddress);

        case 28:
          _context.t7 = _context.sent;

          if ((0, _context.t6)(_context.t7)) {
            _context.next = 39;
            break;
          }

          _context.t8 = put;
          _context.t9 = productActivationActions;
          _context.next = 34;
          return select(getLocaleBase);

        case 34:
          _context.t10 = _context.sent.pg1.emailErr;
          _context.t11 = _context.t9.setEmailAddressError.call(_context.t9, _context.t10);
          _context.next = 38;
          return (0, _context.t8)(_context.t11);

        case 38:
          errored = true;

        case 39:
          _context.next = 41;
          return select(getTermsAccepted);

        case 41:
          if (_context.sent) {
            _context.next = 51;
            break;
          }

          _context.t12 = put;
          _context.t13 = productActivationActions;
          _context.next = 46;
          return select(getLocaleBase);

        case 46:
          _context.t14 = _context.sent.pg1.termsErr;
          _context.t15 = _context.t13.setTermsAcceptedError.call(_context.t13, _context.t14);
          _context.next = 50;
          return (0, _context.t12)(_context.t15);

        case 50:
          errored = true;

        case 51:
          return _context.abrupt("return", !errored);

        case 52:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$4);
}
function handleVerifyResponse(data, navigate) {
  return regeneratorRuntime.wrap(function handleVerifyResponse$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(data === "")) {
            _context2.next = 11;
            break;
          }

          _context2.t0 = put;
          _context2.t1 = productActivationActions;
          _context2.next = 5;
          return select(getLocaleBase);

        case 5:
          _context2.t2 = _context2.sent.pg1.claimAlreadyActivatedErr;
          _context2.t3 = _context2.t1.setApiError.call(_context2.t1, _context2.t2);
          _context2.next = 9;
          return (0, _context2.t0)(_context2.t3);

        case 9:
          _context2.next = 110;
          break;

        case 11:
          if (!(data.validate === "-1")) {
            _context2.next = 22;
            break;
          }

          _context2.t4 = put;
          _context2.t5 = productActivationActions;
          _context2.next = 16;
          return select(getLocaleBase);

        case 16:
          _context2.t6 = _context2.sent.pg1.claim500Err;
          _context2.t7 = _context2.t5.setApiError.call(_context2.t5, _context2.t6);
          _context2.next = 20;
          return (0, _context2.t4)(_context2.t7);

        case 20:
          _context2.next = 110;
          break;

        case 22:
          if (convertToBoolean(data.validate)) {
            _context2.next = 56;
            break;
          }

          if (!(data.validate_code === "506" || data.validate_code === "507")) {
            _context2.next = 34;
            break;
          }

          _context2.t8 = put;
          _context2.t9 = productActivationActions;
          _context2.next = 28;
          return select(getLocaleBase);

        case 28:
          _context2.t10 = _context2.sent.pg1.claimInvalidActivationCodeErr;
          _context2.t11 = _context2.t9.setIdError.call(_context2.t9, _context2.t10);
          _context2.next = 32;
          return (0, _context2.t8)(_context2.t11);

        case 32:
          _context2.next = 54;
          break;

        case 34:
          if (!(data.validate_code === "508")) {
            _context2.next = 45;
            break;
          }

          _context2.t12 = put;
          _context2.t13 = productActivationActions;
          _context2.next = 39;
          return select(getLocaleBase);

        case 39:
          _context2.t14 = _context2.sent.pg1.claimAlreadyActivatedErr;
          _context2.t15 = _context2.t13.setIdError.call(_context2.t13, _context2.t14);
          _context2.next = 43;
          return (0, _context2.t12)(_context2.t15);

        case 43:
          _context2.next = 54;
          break;

        case 45:
          if (!(data.validate_code === "-1")) {
            _context2.next = 54;
            break;
          }

          _context2.t16 = put;
          _context2.t17 = productActivationActions;
          _context2.next = 50;
          return select(getLocaleBase);

        case 50:
          _context2.t18 = _context2.sent.pg1.claimInvalidActivationCodeErr;
          _context2.t19 = _context2.t17.setIdError.call(_context2.t17, _context2.t18);
          _context2.next = 54;
          return (0, _context2.t16)(_context2.t19);

        case 54:
          _context2.next = 110;
          break;

        case 56:
          if (!convertToBoolean(data.validate)) {
            _context2.next = 102;
            break;
          }

          _context2.next = 59;
          return put(setFirstName(data.firstname));

        case 59:
          _context2.next = 61;
          return put(setLastName(data.lastname));

        case 61:
          _context2.next = 63;
          return put(setExistingUser(data.ExistingUser));

        case 63:
          _context2.next = 65;
          return put(setCatCode(data.catCode));

        case 65:
          _context2.next = 67;
          return put(setOrgId(data.orgID));

        case 67:
          _context2.next = 69;
          return put(setVendor(data.vendor));

        case 69:
          _context2.next = 71;
          return put(setDuration(data.duration));

        case 71:
          _context2.next = 73;
          return put(setLangList(data.lang_list));

        case 73:
          _context2.next = 75;
          return put(setProductType(data.product_type));

        case 75:
          _context2.next = 77;
          return put(setSerialNumber(data.serial_number));

        case 77:
          _context2.next = 79;
          return put(setConsumables(data.consumables));

        case 79:
          _context2.next = 81;
          return put(setConsumablesType(data.consumables_type));

        case 81:
          _context2.next = 83;
          return select(getIsActivelySoldProduct);

        case 83:
          if (!_context2.sent) {
            _context2.next = 92;
            break;
          }

          _context2.next = 86;
          return put(computeLearningLanguageState());

        case 86:
          _context2.next = 88;
          return put(computeProductName());

        case 88:
          _context2.next = 90;
          return call(navigate, "/step-2");

        case 90:
          _context2.next = 100;
          break;

        case 92:
          _context2.t20 = put;
          _context2.t21 = productActivationActions;
          _context2.next = 96;
          return select(getLocaleBase);

        case 96:
          _context2.t22 = _context2.sent.pg1.claimProdTypeErr;
          _context2.t23 = _context2.t21.setIdError.call(_context2.t21, _context2.t22);
          _context2.next = 100;
          return (0, _context2.t20)(_context2.t23);

        case 100:
          _context2.next = 110;
          break;

        case 102:
          _context2.t24 = put;
          _context2.t25 = productActivationActions;
          _context2.next = 106;
          return select(getLocaleBase);

        case 106:
          _context2.t26 = _context2.sent.pg1.claim500Err;
          _context2.t27 = _context2.t25.setApiError.call(_context2.t25, _context2.t26);
          _context2.next = 110;
          return (0, _context2.t24)(_context2.t27);

        case 110:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$3);
}

var _marked$3 = /*#__PURE__*/regeneratorRuntime.mark(handleCheckResponse);
function handleCheckResponse(data) {
  return regeneratorRuntime.wrap(function handleCheckResponse$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (Object.prototype.hasOwnProperty.call(data, "licenses")) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return put(setLicenses([]));

        case 3:
          _context.next = 7;
          break;

        case 5:
          _context.next = 7;
          return put(setLicenses(data.licenses));

        case 7:
          _context.next = 9;
          return put(checkSelectedLearningLanguage());

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$3);
}

var _marked$2 = /*#__PURE__*/regeneratorRuntime.mark(validateClaimUserInput),
    _marked2$2 = /*#__PURE__*/regeneratorRuntime.mark(handleClaimResponse);
function validateClaimUserInput() {
  var existingUser, errored, learningLanguageError, password, confirmPassword;
  return regeneratorRuntime.wrap(function validateClaimUserInput$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getExistingUserBoolean);

        case 2:
          existingUser = _context.sent;
          _context.next = 5;
          return select(getIsSubmitting);

        case 5:
          if (!_context.sent) {
            _context.next = 7;
            break;
          }

          return _context.abrupt("return", false);

        case 7:
          _context.next = 9;
          return put(setIsSubmitting(true));

        case 9:
          errored = false;
          _context.next = 12;
          return put(clearErrors());

        case 12:
          _context.next = 14;
          return select(getFirstName);

        case 14:
          if (_context.sent) {
            _context.next = 24;
            break;
          }

          _context.t0 = put;
          _context.t1 = productActivationActions;
          _context.next = 19;
          return select(getLocaleBase);

        case 19:
          _context.t2 = _context.sent.pg2.firstNameErr;
          _context.t3 = _context.t1.setFirstNameError.call(_context.t1, _context.t2);
          _context.next = 23;
          return (0, _context.t0)(_context.t3);

        case 23:
          errored = true;

        case 24:
          _context.next = 26;
          return select(getLastName);

        case 26:
          if (_context.sent) {
            _context.next = 36;
            break;
          }

          _context.t4 = put;
          _context.t5 = productActivationActions;
          _context.next = 31;
          return select(getLocaleBase);

        case 31:
          _context.t6 = _context.sent.pg2.lastNameErr;
          _context.t7 = _context.t5.setLastNameError.call(_context.t5, _context.t6);
          _context.next = 35;
          return (0, _context.t4)(_context.t7);

        case 35:
          errored = true;

        case 36:
          _context.t8 = !existingUser;

          if (!_context.t8) {
            _context.next = 41;
            break;
          }

          _context.next = 40;
          return select(getPassword);

        case 40:
          _context.t8 = !_context.sent;

        case 41:
          if (!_context.t8) {
            _context.next = 51;
            break;
          }

          _context.t9 = put;
          _context.t10 = productActivationActions;
          _context.next = 46;
          return select(getLocaleBase);

        case 46:
          _context.t11 = _context.sent.pg2.passwordErr;
          _context.t12 = _context.t10.setPasswordError.call(_context.t10, _context.t11);
          _context.next = 50;
          return (0, _context.t9)(_context.t12);

        case 50:
          errored = true;

        case 51:
          _context.t13 = !existingUser;

          if (!_context.t13) {
            _context.next = 56;
            break;
          }

          _context.next = 55;
          return select(getConfirmPassword);

        case 55:
          _context.t13 = !_context.sent;

        case 56:
          if (!_context.t13) {
            _context.next = 66;
            break;
          }

          _context.t14 = put;
          _context.t15 = productActivationActions;
          _context.next = 61;
          return select(getLocaleBase);

        case 61:
          _context.t16 = _context.sent.pg2.confirmErr;
          _context.t17 = _context.t15.setConfirmPasswordError.call(_context.t15, _context.t16);
          _context.next = 65;
          return (0, _context.t14)(_context.t17);

        case 65:
          errored = true;

        case 66:
          _context.next = 68;
          return select(getCurrencyCode);

        case 68:
          if (_context.sent) {
            _context.next = 78;
            break;
          }

          _context.t18 = put;
          _context.t19 = productActivationActions;
          _context.next = 73;
          return select(getLocaleBase);

        case 73:
          _context.t20 = _context.sent.pg2.currencyErr;
          _context.t21 = _context.t19.setCurrencyError.call(_context.t19, _context.t20);
          _context.next = 77;
          return (0, _context.t18)(_context.t21);

        case 77:
          errored = true;

        case 78:
          _context.next = 80;
          return select(getLearningLanguageCode);

        case 80:
          if (_context.sent) {
            _context.next = 92;
            break;
          }

          _context.t22 = put;
          _context.t23 = productActivationActions;
          _context.next = 85;
          return select(getLocaleBase);

        case 85:
          _context.t24 = _context.sent.pg2.learningErr;
          _context.t25 = _context.t23.setLearningLanguageError.call(_context.t23, _context.t24);
          _context.next = 89;
          return (0, _context.t22)(_context.t25);

        case 89:
          errored = true;
          _context.next = 98;
          break;

        case 92:
          _context.next = 94;
          return put(checkSelectedLearningLanguage());

        case 94:
          _context.next = 96;
          return select(getIsInvalidLearningLanguageSelected);

        case 96:
          learningLanguageError = _context.sent;

          if (!errored) {
            errored = learningLanguageError;
          }

        case 98:
          _context.next = 100;
          return select(getPassword);

        case 100:
          password = _context.sent;
          _context.next = 103;
          return select(getConfirmPassword);

        case 103:
          confirmPassword = _context.sent;

          if (!(!existingUser && password !== confirmPassword)) {
            _context.next = 114;
            break;
          }

          _context.t26 = put;
          _context.t27 = productActivationActions;
          _context.next = 109;
          return select(getLocaleBase);

        case 109:
          _context.t28 = _context.sent.pg2.matchErr;
          _context.t29 = _context.t27.setConfirmPasswordError.call(_context.t27, _context.t28);
          _context.next = 113;
          return (0, _context.t26)(_context.t29);

        case 113:
          errored = true;

        case 114:
          if (!errored) {
            _context.next = 117;
            break;
          }

          _context.next = 117;
          return put(setIsSubmitting(false));

        case 117:
          return _context.abrupt("return", !errored);

        case 118:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$2);
}
function handleClaimResponse(data, navigate, location) {
  var url;
  return regeneratorRuntime.wrap(function handleClaimResponse$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!data) {
            _context2.next = 33;
            break;
          }

          if (convertToBoolean(data.result)) {
            _context2.next = 23;
            break;
          }

          if (!(data.code === 101 || data.code === 201)) {
            _context2.next = 13;
            break;
          }

          _context2.t0 = put;
          _context2.t1 = productActivationActions;
          _context2.next = 7;
          return select(getLocaleBase);

        case 7:
          _context2.t2 = _context2.sent.pg1.reqError;
          _context2.t3 = _context2.t1.setPageError.call(_context2.t1, _context2.t2);
          _context2.next = 11;
          return (0, _context2.t0)(_context2.t3);

        case 11:
          _context2.next = 21;
          break;

        case 13:
          _context2.t4 = put;
          _context2.t5 = productActivationActions;
          _context2.next = 17;
          return select(getLocaleBase);

        case 17:
          _context2.t6 = _context2.sent.pg1.claim500Err;
          _context2.t7 = _context2.t5.setPageError.call(_context2.t5, _context2.t6);
          _context2.next = 21;
          return (0, _context2.t4)(_context2.t7);

        case 21:
          _context2.next = 31;
          break;

        case 23:
          url = new URL(data.redirect_url);
          url.searchParams["delete"]("accepted_terms"); // it's coming back already set to false

          url.searchParams.append("accepted_terms", "true");
          url.protocol = "https:"; // this should be fixed on the server

          _context2.next = 29;
          return put(setRedirectUrl(url.toString()));

        case 29:
          _context2.next = 31;
          return call(navigate, "/step-3");

        case 31:
          _context2.next = 41;
          break;

        case 33:
          _context2.t8 = put;
          _context2.t9 = productActivationActions;
          _context2.next = 37;
          return select(getLocaleBase);

        case 37:
          _context2.t10 = _context2.sent.pg1.claim500Err;
          _context2.t11 = _context2.t9.setPageError.call(_context2.t9, _context2.t10);
          _context2.next = 41;
          return (0, _context2.t8)(_context2.t11);

        case 41:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$2);
}

var _marked$1 = /*#__PURE__*/regeneratorRuntime.mark(verifyId),
    _marked2$1 = /*#__PURE__*/regeneratorRuntime.mark(check),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(claim),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(sagas$1);
// from within the `check()` saga, which means, we skipped step-1 of the activation process
// because user was redirected directly to step-2, with code and email in url.

function verifyId(action) {
  var params, response, json;
  return regeneratorRuntime.wrap(function verifyId$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = action;

          if (!_context.t0) {
            _context.next = 5;
            break;
          }

          _context.next = 4;
          return select(getIsSubmitting);

        case 4:
          _context.t0 = _context.sent;

        case 5:
          if (!_context.t0) {
            _context.next = 7;
            break;
          }

          return _context.abrupt("return");

        case 7:
          _context.next = 9;
          return put(setIsSubmitting(true));

        case 9:
          if (!(typeof action !== "undefined")) {
            _context.next = 15;
            break;
          }

          return _context.delegateYield(validateUserInput(), "t1", 11);

        case 11:
          if (_context.t1) {
            _context.next = 15;
            break;
          }

          _context.next = 14;
          return put(setIsSubmitting(false));

        case 14:
          return _context.abrupt("return");

        case 15:
          params = new URLSearchParams();
          _context.t2 = params;
          _context.next = 19;
          return select(getIdFull);

        case 19:
          _context.t3 = _context.sent;

          _context.t2.append.call(_context.t2, "claimcode", _context.t3);

          _context.t4 = params;
          _context.next = 24;
          return select(getEmailAddress);

        case 24:
          _context.t5 = _context.sent;

          _context.t4.append.call(_context.t4, "emailaddress", _context.t5);

          params.append("timestamp", new Date().getTime()); // cannot use promises and still interact with redux so we use this style:

          _context.prev = 27;
          _context.next = 30;
          return call(fetch, withTier("api/customer/getActivationDetails"), {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" // necessary to avoid CORS rejection

            },
            body: params.toString()
          });

        case 30:
          response = _context.sent;
          _context.next = 33;
          return call([response, "json"]);

        case 33:
          json = _context.sent;

          if (!(typeof action === "undefined")) {
            _context.next = 38;
            break;
          }

          return _context.delegateYield(handleVerifyResponse(json, null), "t6", 36);

        case 36:
          _context.next = 39;
          break;

        case 38:
          return _context.delegateYield(handleVerifyResponse(json, action.payload.navigate), "t7", 39);

        case 39:
          _context.next = 51;
          break;

        case 41:
          _context.prev = 41;
          _context.t8 = _context["catch"](27);
          _context.t9 = put;
          _context.t10 = productActivationActions;
          _context.next = 47;
          return select(getLocaleBase);

        case 47:
          _context.t11 = _context.sent.pg1.claim500Err;
          _context.t12 = _context.t10.setApiError.call(_context.t10, _context.t11);
          _context.next = 51;
          return (0, _context.t9)(_context.t12);

        case 51:
          _context.prev = 51;
          _context.next = 54;
          return put(setIsSubmitting(false));

        case 54:
          return _context.finish(51);

        case 55:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$1, null, [[27, 41, 51, 55]]);
}
function check(action) {
  var jsonParams, response, json;
  return regeneratorRuntime.wrap(function check$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!action.payload.runVerifyId) {
            _context2.next = 3;
            break;
          }

          _context2.next = 3;
          return call(verifyId);

        case 3:
          _context2.next = 5;
          return select(getIsSubmitting);

        case 5:
          if (!_context2.sent) {
            _context2.next = 7;
            break;
          }

          return _context2.abrupt("return");

        case 7:
          _context2.next = 9;
          return put(setIsSubmitting(true));

        case 9:
          _context2.next = 11;
          return select(getEmailAddress);

        case 11:
          _context2.t0 = _context2.sent;
          _context2.next = 14;
          return select(getLangList);

        case 14:
          _context2.t1 = _context2.sent;
          _context2.t2 = {
            language: _context2.t1,
            usable: "Y"
          };
          jsonParams = {
            email: _context2.t0,
            languages: _context2.t2
          };
          _context2.prev = 17;
          _context2.next = 20;
          return call(fetch, withTier("api/customer/getUserDetails"), {
            method: "POST",
            mode: "cors",
            headers: {
              accept: "application/json",
              "content-type": "application/json"
            },
            body: JSON.stringify(jsonParams)
          });

        case 20:
          response = _context2.sent;
          _context2.next = 23;
          return call([response, "json"]);

        case 23:
          json = _context2.sent;
          return _context2.delegateYield(handleCheckResponse(json), "t3", 25);

        case 25:
          _context2.next = 27;
          return put(setIsSubmitting(false));

        case 27:
          _context2.next = 39;
          break;

        case 29:
          _context2.prev = 29;
          _context2.t4 = _context2["catch"](17);
          _context2.t5 = put;
          _context2.t6 = productActivationActions;
          _context2.next = 35;
          return select(getLocaleBase);

        case 35:
          _context2.t7 = _context2.sent.pg1.claim500Err;
          _context2.t8 = _context2.t6.setPageError.call(_context2.t6, _context2.t7);
          _context2.next = 39;
          return (0, _context2.t5)(_context2.t8);

        case 39:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$1, null, [[17, 29]]);
}
function claim(action) {
  var fixSpanish, p, params, response, json;
  return regeneratorRuntime.wrap(function claim$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield(validateClaimUserInput(), "t0", 1);

        case 1:
          if (_context3.t0) {
            _context3.next = 3;
            break;
          }

          return _context3.abrupt("return");

        case 3:
          // From page 2 Liferay code: this is the way parameters are passed in to the page from the Liferay server
          //
          // // ignored: does not seem interesting
          // <input type="hidden" id="new-locale-code" value="" />
          //
          // // ignored: liferay would default to USD but we will force the user to choose
          // <input type="hidden" id="new-currency-code" value="USD" />
          //
          // <input type="hidden" id="new-tosub-lang-code" />
          //
          // <input type="hidden" id="claim-currency" value="usd" />
          //
          // // wyates: just send an empty string
          // <input type="hidden" value="pass" id="new-usr-pass" />
          // if ($('#claim-exist-usr').val() == "N") {
          //   claim_pass_en = $('#' + langtoDisplay + '-fpass').val();  // password input field
          //   usr_type = "New";
          // }
          // else {
          //   claim_pass_en = $('#new-usr-pass').val();  // what?
          //   usr_type = "Old";
          // }
          // Liferay was sending es-US for Spanish locale
          fixSpanish = function fixSpanish(l) {
            return l.toLowerCase() === "es-419" ? "es-US" : l;
          };

          p = {};
          _context3.next = 7;
          return select(getIdFull);

        case 7:
          p["claimcode"] = _context3.sent;
          _context3.next = 10;
          return select(getEmailAddress);

        case 10:
          p["Email_ID"] = _context3.sent;
          p["submission_Date"] = new Date().getTime();
          _context3.next = 14;
          return select(getEmailAddress);

        case 14:
          p["loginID"] = _context3.sent;
          _context3.next = 17;
          return select(getSiteId);

        case 17:
          p["siteID"] = _context3.sent;
          _context3.t1 = fixSpanish;
          _context3.next = 21;
          return select(getLocaleForClaim);

        case 21:
          _context3.t2 = _context3.sent;
          p["localE"] = (0, _context3.t1)(_context3.t2);
          _context3.next = 25;
          return select(getFirstName);

        case 25:
          p["First_Name"] = _context3.sent;
          _context3.next = 28;
          return select(getLastName);

        case 28:
          p["Last_Name"] = _context3.sent;
          _context3.next = 31;
          return select(getExternalRefId);

        case 31:
          p["externalReferenceID"] = _context3.sent;
          _context3.next = 34;
          return select(getCurrencyOrgId);

        case 34:
          p["org_id"] = _context3.sent;
          _context3.next = 37;
          return select(getUserType);

        case 37:
          p["userType"] = _context3.sent;
          _context3.next = 40;
          return select(getPassword);

        case 40:
          p["password"] = _context3.sent;
          _context3.next = 43;
          return select(getCurrencyCode);

        case 43:
          p["currency_code"] = _context3.sent;
          p["email_event"] = "RS_CLAIM_SENDMAIL";
          _context3.next = 47;
          return select(getSerialNumber);

        case 47:
          p["serial_number"] = _context3.sent;
          _context3.next = 50;
          return select(getConsumables);

        case 50:
          p["group_consumables"] = _context3.sent;
          _context3.next = 53;
          return select(getConsumablesType);

        case 53:
          p["consumables_type"] = _context3.sent;
          _context3.next = 56;
          return select(getVendor);

        case 56:
          p["orderSource"] = _context3.sent;
          // FIXME seems reasonable!
          // FIXME this is always null, but in Vue it wasn't
          p["consent_type"] = window.gdpr && window.gdpr.email_consent || null;
          p["country_code"] = window.gdpr && window.gdpr.country_code || null;
          params = new URLSearchParams(p);
          _context3.prev = 60;
          _context3.next = 63;
          return call(fetch, withTier("api/public/external/provision/claim"), {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" // necessary to avoid CORS rejection

            },
            body: params.toString()
          });

        case 63:
          response = _context3.sent;
          _context3.next = 66;
          return call([response, "json"]);

        case 66:
          json = _context3.sent;
          return _context3.delegateYield(handleClaimResponse(json, action.payload.navigate, action.payload.location), "t3", 68);

        case 68:
          _context3.next = 80;
          break;

        case 70:
          _context3.prev = 70;
          _context3.t4 = _context3["catch"](60);
          _context3.t5 = put;
          _context3.t6 = productActivationActions;
          _context3.next = 76;
          return select(getLocaleBase);

        case 76:
          _context3.t7 = _context3.sent.pg1.claim500Err;
          _context3.t8 = _context3.t6.setPageError.call(_context3.t6, _context3.t7);
          _context3.next = 80;
          return (0, _context3.t5)(_context3.t8);

        case 80:
          _context3.prev = 80;
          _context3.next = 83;
          return put(setIsSubmitting(false));

        case 83:
          return _context3.finish(80);

        case 84:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[60, 70, 80, 84]]);
}
function sagas$1() {
  return regeneratorRuntime.wrap(function sagas$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(PA_VERIFY_ID, verifyId);

        case 2:
          _context4.next = 4;
          return takeLatest(PA_CHECK, check);

        case 4:
          _context4.next = 6;
          return takeLatest(PA_CLAIM, claim);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

var getSubmissionPayload = function getSubmissionPayload(state) {
  return state[storeRoot$3].submission;
};
var getSubmissionResponse = function getSubmissionResponse(state) {
  return state[storeRoot$3].response;
};
var getSubmissionError = function getSubmissionError(state) {
  return state[storeRoot$3].error;
};
var getIsLoading = function getIsLoading(state) {
  return state[storeRoot$3].isLoading;
};

var freeTrialFormSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSubmissionPayload: getSubmissionPayload,
  getSubmissionResponse: getSubmissionResponse,
  getSubmissionError: getSubmissionError,
  getIsLoading: getIsLoading
});

var setFreeTrialFormSubmission = function setFreeTrialFormSubmission(payload) {
  return {
    type: SET_FREE_TRIAL_FORM_SUBMISSION,
    payload: payload
  };
};
var setFreeTrialIsLoading = function setFreeTrialIsLoading(isLoading) {
  return {
    type: SET_FREE_TRIAL_IS_LOADING,
    payload: isLoading
  };
};
var setFreeTrialSubmissionResponse = function setFreeTrialSubmissionResponse(response) {
  return {
    type: SET_FREE_TRIAL_SUBMISSION_RESPONSE,
    payload: response
  };
};
var setFreeTrialSubmissionStatus = function setFreeTrialSubmissionStatus(status) {
  return {
    type: SET_FREE_TRIAL_SUBMISSION_STATUS,
    payload: status
  };
};
var setFreeTrialSubmissionError = function setFreeTrialSubmissionError(error) {
  return {
    type: SET_FREE_TRIAL_SUBMISSION_ERROR,
    payload: error
  };
};
var clearFreeTrialSubmissionError = function clearFreeTrialSubmissionError() {
  return {
    type: SET_FREE_TRIAL_SUBMISSION_ERROR
  };
};

var freeTrialFormActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setFreeTrialFormSubmission: setFreeTrialFormSubmission,
  setFreeTrialIsLoading: setFreeTrialIsLoading,
  setFreeTrialSubmissionResponse: setFreeTrialSubmissionResponse,
  setFreeTrialSubmissionStatus: setFreeTrialSubmissionStatus,
  setFreeTrialSubmissionError: setFreeTrialSubmissionError,
  clearFreeTrialSubmissionError: clearFreeTrialSubmissionError
});

var freeTrialFormUrl = process.env.STORYBOOK ? "https://iis-gateway.rosettastone.com/api/freetrials" : process.env.RS_FREETRIAL_API;
var sendFreeTrialFormData$1 = function sendFreeTrialFormData(payload) {
  return fetch(freeTrialFormUrl, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(payload)
  }).then(function (response) {
    return response.text();
  }).then(function (responseJson) {
    return responseJson;
  })["catch"](function () {
    return null;
  });
};

var _marked = /*#__PURE__*/regeneratorRuntime.mark(sendFreeTrialFormData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(sagas);

function sendFreeTrialFormData() {
  var data, processedData;
  return regeneratorRuntime.wrap(function sendFreeTrialFormData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getSubmissionPayload);

        case 2:
          data = _context.sent;
          _context.next = 5;
          return put(setFreeTrialSubmissionStatus(submissionStatus.sent));

        case 5:
          _context.next = 7;
          return call(sendFreeTrialFormData$1, data);

        case 7:
          processedData = _context.sent;

          if (processedData) {
            _context.next = 14;
            break;
          }

          _context.next = 11;
          return put(setFreeTrialSubmissionError("Network request failed. Please try again."));

        case 11:
          _context.next = 13;
          return put(setFreeTrialIsLoading(false));

        case 13:
          return _context.abrupt("return");

        case 14:
          _context.next = 16;
          return put(setFreeTrialSubmissionResponse(JSON.parse(processedData)));

        case 16:
          _context.next = 18;
          return put(setFreeTrialSubmissionStatus(submissionStatus.received));

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sagas() {
  return regeneratorRuntime.wrap(function sagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(SET_FREE_TRIAL_FORM_SUBMISSION, sendFreeTrialFormData);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var configureStore = (function (_ref) {
  var element = _ref.element;
  var sagaMiddleware = createSagaMiddleware();
  var store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware))); // List Sagas

  sagaMiddleware.run(sagas$3);
  sagaMiddleware.run(sagas$2);
  sagaMiddleware.run(sagas$1);
  sagaMiddleware.run(sagas);
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, element);
});

var countryData = [{
  value: "China",
  label: "中国"
}, {
  value: "United States",
  label: "美国"
}, {
  value: "Canada",
  label: "加拿大"
}, {
  value: "Afghanistan",
  label: "阿富汗"
}, {
  value: "Albania",
  label: "阿尔巴尼亚"
}, {
  value: "Algeria",
  label: "阿尔及利亚"
}, {
  value: "Andorra",
  label: "安道尔"
}, {
  value: "Angola",
  label: "安哥拉"
}, {
  value: "Antigua and Barbuda",
  label: "安提瓜和巴布达"
}, {
  value: "Argentina",
  label: "阿根廷"
}, {
  value: "Armenia",
  label: "亚美尼亚"
}, {
  value: "Australia",
  label: "澳大利亚"
}, {
  value: "Austria",
  label: "奥地利"
}, {
  value: "Azerbaijan",
  label: "阿塞拜疆"
}, {
  value: "Bahamas",
  label: "巴哈马"
}, {
  value: "Bahrain",
  label: "巴林"
}, {
  value: "Bangladesh",
  label: "孟加拉国"
}, {
  value: "Barbados",
  label: "巴巴多斯"
}, {
  value: "Belarus",
  label: "白俄罗斯"
}, {
  value: "Belgium",
  label: "比利时"
}, {
  value: "Belize",
  label: "伯利兹"
}, {
  value: "Benin",
  label: "贝宁"
}, {
  value: "Bhutan",
  label: "不丹"
}, {
  value: "Bolivia",
  label: "玻利维亚"
}, {
  value: "Bosnia and Herzegovina",
  label: "波斯尼亚 – 黑塞哥维那"
}, {
  value: "Botswana",
  label: "博茨瓦纳"
}, {
  value: "Brazil",
  label: "巴西"
}, {
  value: "Brunei",
  label: "文莱达鲁萨兰国"
}, {
  value: "Bulgaria",
  label: "保加利亚"
}, {
  value: "Burkina Faso",
  label: "布基纳法索"
}, {
  value: "Burundi",
  label: "蒲隆地"
}, {
  value: "Cambodia",
  label: "柬埔寨"
}, {
  value: "Cameroon",
  label: "喀麦隆"
}, {
  value: "Cape Verde",
  label: "佛得角"
}, {
  value: "Chad",
  label: "乍得"
}, {
  value: "Chile",
  label: "智利"
}, {
  value: "Colombia",
  label: "哥伦比亚"
}, {
  value: "Democratic Republic of Congo",
  label: "刚果民主共和国"
}, {
  value: "Republic of Congo",
  label: "刚果共和国"
}, {
  value: "Costa Rica",
  label: "哥斯达黎加"
}, {
  value: "Ivory Coast",
  label: "科特迪瓦"
}, {
  value: "Croatia",
  label: "克罗地亚"
}, {
  value: "Cuba",
  label: "古巴"
}, {
  value: "Cyprus",
  label: "塞浦路斯"
}, {
  value: "Czechia",
  label: "捷克共和国"
}, {
  value: "Denmark",
  label: "丹麦"
}, {
  value: "Djibouti",
  label: "吉布提"
}, {
  value: "Dominica",
  label: "多米尼克"
}, {
  value: "Dominican Republic",
  label: "多米尼加共和国"
}, {
  value: "Ecuador",
  label: "厄瓜多尔"
}, {
  value: "Egypt",
  label: "埃及"
}, {
  value: "El Salvador",
  label: "萨尔瓦多"
}, {
  value: "Equatorial Guinea",
  label: "赤道几内亚"
}, {
  value: "Estonia",
  label: "爱沙尼亚"
}, {
  value: "Ethiopia",
  label: "埃塞俄比亚"
}, {
  value: "Fiji",
  label: "斐济"
}, {
  value: "Finland",
  label: "芬兰"
}, {
  value: "France",
  label: "法国"
}, {
  value: "Gabon",
  label: "加蓬"
}, {
  value: "Gambia",
  label: "冈比亚"
}, {
  value: "Georgia",
  label: "格鲁吉亚"
}, {
  value: "Germany",
  label: "德国"
}, {
  value: "Ghana",
  label: "加纳"
}, {
  value: "Greece",
  label: "希腊"
}, {
  value: "Grenada",
  label: "格林纳达"
}, {
  value: "Guatemala",
  label: "危地马拉"
}, {
  value: "Guinea",
  label: "几内亚"
}, {
  value: "Guinea Bissau",
  label: "几内亚比绍"
}, {
  value: "Guyana",
  label: "圭亚那"
}, {
  value: "Haiti",
  label: "海地"
}, {
  value: "Honduras",
  label: "洪都拉斯"
}, {
  value: "Hungary",
  label: "匈牙利"
}, {
  value: "Iceland",
  label: "冰岛"
}, {
  value: "India",
  label: "印度"
}, {
  value: "Indonesia",
  label: "印度尼西亚"
}, {
  value: "Iran",
  label: "伊朗"
}, {
  value: "Iraq",
  label: "伊拉克"
}, {
  value: "Ireland",
  label: "爱尔兰"
}, {
  value: "Israel",
  label: "以色列"
}, {
  value: "Italy",
  label: "意大利"
}, {
  value: "Jamaica",
  label: "牙买加"
}, {
  value: "Japan",
  label: "日本"
}, {
  value: "Jordan",
  label: "约旦"
}, {
  value: "Kazakhstan",
  label: "哈萨克斯坦"
}, {
  value: "Kenya",
  label: "肯尼亚"
}, {
  value: "Kuwait",
  label: "科威特"
}, {
  value: "Kyrgyzstan",
  label: "吉尔吉斯斯坦"
}, {
  value: "Laos",
  label: "老挝"
}, {
  value: "Latvia",
  label: "拉脱维亚"
}, {
  value: "Lebanon",
  label: "黎巴嫩"
}, {
  value: "Lesotho",
  label: "莱索托"
}, {
  value: "Liberia",
  label: "利比里亚"
}, {
  value: "Libya",
  label: "利比亚"
}, {
  value: "Liechtenstein",
  label: "列支敦士登"
}, {
  value: "Lithuania",
  label: "立陶宛"
}, {
  value: "Luxembourg",
  label: "卢森堡"
}, {
  value: "Macedonia",
  label: "马其顿"
}, {
  value: "Madagascar",
  label: "马达加斯加"
}, {
  value: "Malawi",
  label: "马拉维"
}, {
  value: "Malaysia",
  label: "马来西亚"
}, {
  value: "Maldives",
  label: "马尔代夫"
}, {
  value: "Mali",
  label: "马里"
}, {
  value: "Malta",
  label: "马耳他"
}, {
  value: "Mauritania",
  label: "毛里塔尼亚"
}, {
  value: "Mauritius",
  label: "毛里求斯"
}, {
  value: "Mexico",
  label: "墨西哥"
}, {
  value: "Moldova",
  label: "摩尔多瓦"
}, {
  value: "Monaco",
  label: "摩纳哥"
}, {
  value: "Mongolia",
  label: "蒙古"
}, {
  value: "Montenegro",
  label: "黑山"
}, {
  value: "Morocco",
  label: "摩洛哥"
}, {
  value: "Mozambique",
  label: "莫桑比克"
}, {
  value: "Namibia",
  label: "纳米比亚"
}, {
  value: "Nepal",
  label: "尼泊尔"
}, {
  value: "Netherlands",
  label: "荷兰"
}, {
  value: "New Zealand",
  label: "新西兰"
}, {
  value: "Nicaragua",
  label: "尼加拉瓜"
}, {
  value: "Niger",
  label: "尼日尔"
}, {
  value: "Nigeria",
  label: "尼日利亚"
}, {
  value: "Norway",
  label: "挪威"
}, {
  value: "Oman",
  label: "阿曼"
}, {
  value: "Pakistan",
  label: "巴基斯坦"
}, {
  value: "Palestine",
  label: "巴勒斯坦"
}, {
  value: "Panama",
  label: "巴拿马"
}, {
  value: "Papua New Guinea",
  label: "巴布亚新几内亚"
}, {
  value: "Paraguay",
  label: "巴拉圭"
}, {
  value: "Peru",
  label: "秘鲁"
}, {
  value: "Philippines",
  label: "菲律宾"
}, {
  value: "Poland",
  label: "波兰"
}, {
  value: "Portugal",
  label: "葡萄牙"
}, {
  value: "Qatar",
  label: "卡塔尔"
}, {
  value: "Romania",
  label: "罗马尼亚"
}, {
  value: "Russia",
  label: "俄罗斯"
}, {
  value: "Rwanda",
  label: "卢旺达"
}, {
  value: "Samoa",
  label: "萨摩亚"
}, {
  value: "San Marino",
  label: "圣马力诺"
}, {
  value: "Saudi Arabia",
  label: "沙特阿拉伯"
}, {
  value: "Senegal",
  label: "塞内加尔"
}, {
  value: "Serbia",
  label: "塞尔维亚"
}, {
  value: "Seychelles",
  label: "塞舌尔"
}, {
  value: "Sierra Leone",
  label: "塞拉利昂"
}, {
  value: "Singapore",
  label: "新加坡"
}, {
  value: "Slovakia",
  label: "斯洛伐克"
}, {
  value: "Slovenia",
  label: "斯洛文尼亚"
}, {
  value: "South Africa",
  label: "南非"
}, {
  value: "South Korea",
  label: "韩国"
}, {
  value: "South Sudan",
  label: "南蘇丹"
}, {
  value: "Spain",
  label: "西班牙"
}, {
  value: "Sri Lanka",
  label: "斯里兰卡"
}, {
  value: "St Kitts and Nevis",
  label: "圣基茨和尼维斯"
}, {
  value: "St Lucia",
  label: "圣卢西亚"
}, {
  value: "St Vincent and the Grenadines",
  label: "圣文森特和格林纳丁斯"
}, {
  value: "Sudan",
  label: "苏丹"
}, {
  value: "Suriname",
  label: "苏里南"
}, {
  value: "Swaziland",
  label: "史瓦济兰"
}, {
  value: "Sweden",
  label: "瑞典"
}, {
  value: "Switzerland",
  label: "瑞士"
}, {
  value: "Syria",
  label: "叙利亚"
}, {
  value: "Tajikistan",
  label: "塔吉克斯坦"
}, {
  value: "Tanzania",
  label: "坦桑尼亚"
}, {
  value: "Thailand",
  label: "泰国"
}, {
  value: "Togo",
  label: "多哥"
}, {
  value: "Tonga",
  label: "東加"
}, {
  value: "Trinidad and Tobago",
  label: "特立尼达和多巴哥"
}, {
  value: "Tunisia",
  label: "突尼斯"
}, {
  value: "Turkey",
  label: "土耳其"
}, {
  value: "Turkmenistan",
  label: "土库曼"
}, {
  value: "Tuvalu",
  label: "吐瓦鲁"
}, {
  value: "Uganda",
  label: "乌干达"
}, {
  value: "Ukraine",
  label: "乌克兰"
}, {
  value: "United Arab Emirates",
  label: "阿拉伯联合酋长国"
}, {
  value: "United Kingdom",
  label: "英国"
}, {
  value: "Uruguay",
  label: "乌拉圭"
}, {
  value: "Uzbekistan",
  label: "乌兹别克斯坦"
}, {
  value: "Venezuela",
  label: "委内瑞拉"
}, {
  value: "Vietnam",
  label: "越南"
}, {
  value: "Yemen",
  label: "也门"
}, {
  value: "Zambia",
  label: "赞比亚"
}, {
  value: "Zimbabwe",
  label: "津巴布韦"
}];

var businessData = {
  navTitle: "Navigate Hub",
  noDropDowns: [{
    title: "Customer Stories",
    url_slug: "case-studies-business"
  }],
  sections: [{
    title: "Business Need",
    sublevels: [{
      url_slug: "case-for-language-learning",
      title: "The Case for Language Learning"
    }, {
      url_slug: "customer-service",
      title: "Customer Service"
    }, {
      url_slug: "workforce-development",
      title: "Workforce Development"
    }, {
      url_slug: "productivity-collaboration",
      title: "Productivity & Collaboration"
    }, {
      url_slug: "workplace-safety",
      title: "Workplace Safety"
    }, {
      url_slug: "diversity-inclusion",
      title: "Diversity & Inclusion"
    }, {
      url_slug: "english-language-learning-2",
      title: "English Language Learning"
    }, {
      url_slug: "market-expansion",
      title: "Market Expansion"
    }]
  }, {
    title: "Resource Type",
    sublevels: [{
      url_slug: "bus-infographics",
      title: "Infographics"
    }, {
      url_slug: "white-papers-business",
      title: "Reports"
    }, {
      url_slug: "ebooks-corporate",
      title: "eBooks"
    }, {
      url_slug: "videos",
      title: "Videos"
    }, {
      url_slug: "webinars",
      title: "Webinars"
    }, {
      url_slug: "factsheet-business",
      title: "Fact Sheets"
    }]
  }]
};
var k12Data = {
  navTitle: "Navigate Hub",
  noDropDowns: [{
    title: "Customer Stories",
    url_slug: "customer-success-stories"
  }],
  sections: [{
    title: "Need",
    sublevels: [{
      url_slug: "world-language",
      title: "World Language"
    }, {
      url_slug: "english-language-learning",
      title: "English Language"
    }, {
      url_slug: "adult-education",
      title: "Adult Education"
    }]
  }, {
    title: "Implementation",
    sublevels: [{
      url_slug: "blended-learning",
      title: "Blended Learning"
    }, {
      url_slug: "online-learning",
      title: "Online Learning"
    }]
  }, {
    title: "Type",
    sublevels: [{
      url_slug: "infographics",
      title: "Infographics"
    }, {
      url_slug: "white-papers",
      title: "Reports"
    }, {
      url_slug: "ebooks",
      title: "eBooks"
    }, {
      url_slug: "video",
      title: "Videos"
    }, {
      url_slug: "k12-webinars",
      title: "Webinars"
    }, {
      url_slug: "podcasts",
      title: "Podcasts"
    }, {
      url_slug: "brochures",
      title: "Brochures"
    }, {
      url_slug: "teacher-resources",
      title: "Teacher Resources"
    }]
  }]
};
var serviceData = {
  navTitle: "Navigate Hub",
  sections: [{
    title: "Foundations",
    sublevels: [{
      title: "for Education"
    }, {
      url_slug: "getting-started-foundations-k12",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-k12-found",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-k12-found",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-k12-found",
      title: "Learner Resources"
    }, {
      title: "for Enterprise"
    }, {
      url_slug: "getting-started-ent-found",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-ent-found",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-ent-found",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-enterprise-foundations",
      title: "Learner Resources"
    }]
  }, {
    title: "Advantage",
    sublevels: [{
      title: "for Education"
    }, {
      url_slug: "getting-started-adv-edu",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-adv-edu",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-adv-edu",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-adv-edu",
      title: "Learner Resources"
    }, {
      title: "for Enterprise"
    }, {
      url_slug: "getting-started-rsa-ent",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-rsa-ent",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-rsa-ent",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-rsa-ent",
      title: "Learner Resources"
    }]
  }, {
    title: "Advanced",
    sublevels: [{
      url_slug: "getting-started-aeb",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-aeb",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-aeb",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-aeb",
      title: "Learner Resources"
    }]
  }, {
    title: "Catalyst",
    sublevels: [{
      url_slug: "getting-started-catalyst",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-catalyst",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-catalyst",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-catalyst",
      title: "Learner Resources"
    }]
  } // {
  //   title: 'Team Edition',
  //   sublevels: [
  //     {
  //       url_slug: 'getting-started-team-edition',
  //       title: 'Getting Started',
  //     },
  //     {
  //       url_slug: 'administrator-tools-team-edition',
  //       title: 'Administrator Tools',
  //     },
  //     {
  //       url_slug: 'administrator-resources-team-edition',
  //       title: 'Administrator Resources',
  //     },
  //     {
  //       url_slug: 'learner-resources-team-edition',
  //       title: 'Learner Resources',
  //     },
  //   ],
  // },
  ]
};
var deBusinessData = {
  navTitle: "Hub Navigieren",
  noDropDowns: [{
    title: "Bildung",
    url_slug: "bildungsressourcen"
  }, {
    title: "Unternehmen",
    url_slug: "geschaeftsressourcen"
  }],
  sections: []
};
var deServicesData = {
  navTitle: "Hub Navigieren",
  noDropDowns: [],
  sections: [{
    title: "Produkte",
    sublevels: [{
      title: "Catalyst",
      url_slug: "catalyst"
    }, {
      title: "Rosetta Stone AEB",
      url_slug: "rosetta-stone-aeb"
    }, {
      title: "Rosetta Stone V3",
      url_slug: "v3"
    }, {
      title: "Advantage",
      url_slug: "advantage"
    }, {
      title: "Foundaitons",
      url_slug: "foundations"
    }]
  }, {
    title: "Type",
    sublevels: [{
      title: "Videos: Catalyst",
      url_slug: "catalyst-videos"
    } // {
    //   title: 'Course #4: Get Ready',
    //   url_slug: 'ent-get-ready',
    // },
    // {
    //   title: 'Course #5: Learn Your Resources',
    //   url_slug: 'ent-learn-your-resources',
    // },
    // {
    //   title: 'Course #6: Ready, Set, Learn!',
    //   url_slug: 'edu-ready-set-learn',
    // },
    // {
    //   title: 'Course #7: Progress Checkpoint',
    //   url_slug: 'ent-progress-checkpoint',
    // },
    ]
  }]
};
var ukBusinessData = {
  navTitle: "Navigate Hub",
  sections: [{
    title: "Sector",
    sublevels: [{
      url_slug: "business",
      title: "Business"
    }, {
      url_slug: "education",
      title: "Education"
    }]
  }, {
    title: "Resource Type",
    sublevels: [{
      url_slug: "videos-webinars",
      title: "Videos and Webinars"
    }, {
      url_slug: "infographics",
      title: "Infographics"
    }, {
      url_slug: "reports-ebooks",
      title: "eBooks"
    }, {
      url_slug: "fact-sheets",
      title: "Fact Sheets"
    }]
  }],
  noDropDowns: [{
    url_slug: "customer-stories",
    title: "Customer Stories"
  }]
};
var laBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var esBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var esK12Data = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var esHEDData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var frBusinessData = {
  navTitle: "",
  noDropDowns: [],
  sections: []
};
var brBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var itBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var cnBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};

var filterData = /*#__PURE__*/Object.freeze({
  __proto__: null,
  businessData: businessData,
  k12Data: k12Data,
  serviceData: serviceData,
  deBusinessData: deBusinessData,
  deServicesData: deServicesData,
  ukBusinessData: ukBusinessData,
  laBusinessData: laBusinessData,
  esBusinessData: esBusinessData,
  esK12Data: esK12Data,
  esHEDData: esHEDData,
  frBusinessData: frBusinessData,
  brBusinessData: brBusinessData,
  itBusinessData: itBusinessData,
  cnBusinessData: cnBusinessData
});

var setCartIframeUrl = function setCartIframeUrl(iframeUrl) {
  return {
    type: actionTypes.SET_CART_IFRAME_URL,
    payload: iframeUrl
  };
};
var setShowLoadingMessages = function setShowLoadingMessages(showLoadingMessages) {
  return {
    type: actionTypes.SET_SHOW_LOADING_MESSAGES,
    payload: showLoadingMessages
  };
};
var setIsCartVisible = function setIsCartVisible(isCartVisible) {
  return {
    type: actionTypes.SET_IS_CART_VISIBLE,
    payload: isCartVisible
  };
};
var setIsOverlayVisible = function setIsOverlayVisible(isOverlayVisible) {
  return {
    type: actionTypes.SET_IS_OVERLAY_VISIBLE,
    payload: isOverlayVisible
  };
};

var cartActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setCartIframeUrl: setCartIframeUrl,
  setShowLoadingMessages: setShowLoadingMessages,
  setIsCartVisible: setIsCartVisible,
  setIsOverlayVisible: setIsOverlayVisible
});

var getCartState = function getCartState(state) {
  return state[storeRoot$1];
};

var cartSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCartState: getCartState
});

var setGlobalLanguageId = function setGlobalLanguageId(languageId) {
  return {
    type: SET_GLOBAL_LANGUAGE_ID,
    payload: languageId
  };
};

var globalActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setGlobalLanguageId: setGlobalLanguageId
});

var getLanguageId = function getLanguageId(state) {
  return state[storeRoot].languageId;
};

var globalSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getLanguageId: getLanguageId
});

var searchQueries = function searchQueries(_ref) {
  var hubId = _ref.hubId,
      market = _ref.market,
      indexName = _ref.indexName;
  return [{
    query: "query {\n          items: allAirtable(\n            filter: {\n              table: { eq: \"Items\" }\n              data: { \n                hubs: { eq: \"".concat(hubId, "\" }\n                market: { eq: \"").concat(market, "\" }\n              }\n            }\n          ) {\n            edges {\n              node {\n                id\n                data {\n                  title\n                  thumbnail_url\n                  thumbnail_alt_text\n                  description\n                  url_slug\n                  asset_type\n                  streams\n                }\n              }\n            }\n          }\n        }"),
    transformer: function transformer(_ref2) {
      var data = _ref2.data;
      return data.items.edges.map(function (_ref3) {
        var node = _ref3.node;
        return node;
      });
    },
    // optional
    indexName: indexName // overrides main index name, optional

  }];
};

var algoliaSearchQueries = /*#__PURE__*/Object.freeze({
  __proto__: null,
  searchQueries: searchQueries
});

// Store
var sampleData = {};
var staticData = {
  countryData: countryData,
  filterData: filterData
}; // Store

var leadGenerationStore = {
  leadGenerationActions: leadGenerationActions,
  leadGenerationConstants: leadGenerationConstants,
  leadGenerationSelectors: leadGenerationSelectors
}; // Store

var freeTrialFormStore = {
  freeTrialFormActions: freeTrialFormActions,
  freeTrialFormConstants: freeTrialFormConstants,
  freeTrialFormSelectors: freeTrialFormSelectors
};
var productActivationStore = {
  productActivationActions: productActivationActions,
  productActivationConstants: productActivationConstants,
  productActivationSelectors: productActivationSelectors
};
var emailCollectionStore = {
  emailCollectionActions: emailCollectionActions,
  emailCollectionSelectors: emailCollectionSelectors,
  emailCollectionConstants: emailCollectionConstants
};
var globalStore = {
  globalActions: globalActions,
  globalSelectors: globalSelectors,
  globalConstants: globalConstants
};
var cartStore = {
  cartActions: cartActions,
  cartSelectors: cartSelectors,
  cartConstants: cartConstants
};
var graphQl = {
  algolia: {
    queries: algoliaSearchQueries
  }
};
var store = {
  rootReducer: rootReducer,
  configureStore: configureStore
};

export { cartStore, emailCollectionStore, freeTrialFormStore, globalStore, graphQl, leadGenerationStore, productActivationStore, sampleData, staticData, store };
